import { aiWidgetInfos } from './AiWidgetInfos';

export const widgetTemplates = {
    // Spiritual & Inspiration Widgets
    // spiritualQuoteCard: {
    //     // Main Content
    //     titleText: 'Your Inner Wisdom',
    //     titleColor: '#2d3748',
    //     titleSize: 32,
    //     titleSizeMobile: 28,
    //     titleSizeBig: 36,
    //     titleWeight: '600',
    //     titleFont: '', // Will use globalBigFont
    //     titleEffect: '',
        
    //     // Rich Text Content
    //     richText: '<p>No one else is exactly like you and that\'s your magic.</p><p>Trust your unique path and embrace your authentic self.</p>',
    //     richTextColor: '#4a5568',
    //     richTextSize: 18,
    //     richTextSizeMobile: 15,
    //     richTextSizeBig: 20,
    //     richTextWeight: '400',
    //     richTextFont: '', // Will use globalSmallFont
    //     richTextLineHeight: 1.6,
    //     richTextLineHeightMobile: 1.5,
        
    //     // Top Icon
    //     topIcon: '/img/gold_glitter.png',
    //     showTopIcon: true,
    //     topIconSize: 48,
    //     topIconColor: '#667eea',
    //     topIconInvert: false,           // Icon Invert Toggle
        
    //     // Decorative Symbol (between title and text)
    //     decorativeSymbol: '✦',
    //     showDecorativeSymbol: true,
    //     decorativeSymbolColor: '#9ca3af',
    //     decorativeSymbolSize: 16,
        
    //     // Background Image
    //     backgroundImage: '',
    //     backgroundImageOpacity: 70, // Prozent-Wert für neue ImageContainer
    //     imageEffect: 'none', // none|blur|grayscale|top-fade
        
    //     // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
    //     height: 400,                    // Desktop Height
    //     heightMobile: 1200,             // Mobile Height (Standard: 1200px)
    //     paddingTop: 40,                 // Desktop Padding
    //     paddingTopMobile: 30,           // Mobile Padding
    //     paddingBottom: 40,              // Desktop Padding
    //     paddingBottomMobile: 30,        // Mobile Padding
    //     marginTop: 0,
    //     marginBottom: 40,
    //     borderRadius: 0,                // Straight edges
        
    //     // Layout System
    //     layoutType: 'modern-flat',      // Default Layout
        
    //     // Container Style System (Legacy - wird durch layoutType ersetzt)
    //     containerStyle: 'modern-flat',
    //     containerBackground: '',        // ✅ AI will set this to match backgroundColor
    //     containerPadding: 48,           // Desktop Container Padding
    //     containerPaddingMobile: 32,     // Mobile Container Padding
    //     containerRadius: 0,             // Straight edges
        
    //     // Text Alignment & Responsive
    //     textAlignment: 'center',        // Desktop Text Alignment
    //     textAlignmentMobile: 'center',  // Mobile Text Alignment
        
    //     // Text Margins (Rand zur Wand)
    //     textMarginX: 0,                 // Desktop Text Horizontal Margin
    //     textMarginXMobile: 0,           // Mobile Text Horizontal Margin
        
    //     // Responsive Spacing
    //     iconTitleSpacing: 20,           // Desktop Icon-Title Spacing
    //     iconTitleSpacingMobile: 16,     // Mobile Icon-Title Spacing
    //     titleSymbolSpacing: 16,         // Desktop Title-Symbol Spacing
    //     titleSymbolSpacingMobile: 12,   // Mobile Title-Symbol Spacing
    //     symbolTextSpacing: 24,          // Desktop Symbol-Text Spacing
    //     symbolTextSpacingMobile: 20,    // Mobile Symbol-Text Spacing
        
    //     // Standard Widget Properties
    //     backgroundColor: '#f8fafc',
    //     marginTop: 0,
    //     marginBottom: 40,
    //     borderRadius: 0,
    //     border: false,
    //     borderColor: '#CCCCCC',
    //     minHeight: 500,
        
    //     // Widget Meta (REQUIRED)
    //     imagePreview: '/img/spiritual_quote.jpg',
    //     id: '',
    //     type: 'SpiritualQuoteCard',
    //     name: 'Spiritual Quote Card',
    //     position: '21',
    //     isSelected: false,
    //     cat1: 'Fancy',
    //     cat2: 'Text',
        
    //     // AI Integration (REQUIRED)
    //     aiInfo: aiWidgetInfos.spiritualQuoteCard
    // },

    // // Achievement & Stats Widgets
    // achievementsBanner: {
    //     // Main Title
    //     titleText: 'Our Achievements',
    //     titleColor: '#1e293b',
    //     titleSize: 48,
    //     titleSizeMobile: 36,
    //     titleSizeBig: 56,
    //     titleWeight: '700',
    //     titleFont: '', // Will use globalBigFont
    //     titleEffect: '',
        
    //     // ✅ HIGHLIGHT-SYSTEM für titleText
    //     titleHighlightWords: '', // Komma-getrennte Wörter zum Highlighten
    //     titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
    //     titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
    //     titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
    //     titleHighlightEffect: '', // Text-Effect für highlighted Wörter
    //     titleHighlightSize: 48, // Desktop Font-Größe (gleich wie titleSize)
    //     titleHighlightSizeMobile: 36, // Mobile Font-Größe (gleich wie titleSizeMobile)
    //     titleHighlightSizeBig: 56, // Big Screen Font-Größe (gleich wie titleSizeBig)
    //     titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
    //     titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
        
    //     // Achievement Items (3 containers)
    //     achievement1Number: '1K+',
    //     achievement1Text: 'Happy Customers',
    //     achievement1Icon: '/img/icons/handdrawn/accept.svg',
        
    //     achievement2Number: '2K+',
    //     achievement2Text: 'Projects Completed', 
    //     achievement2Icon: '/img/icons/handdrawn/star.svg',
        
    //     achievement3Number: '10K+',
    //     achievement3Text: 'Hours of Experience',
    //     achievement3Icon: '/img/icons/handdrawn/trophy.svg',
        
    //     // Achievement Styling
    //     numberColor: '#1e293b',
    //     numberSize: 64,
    //     numberSizeMobile: 48,
    //     numberSizeBig: 72,
    //     numberWeight: '800',
    //     numberFont: '', // Will use globalBigFont
        
    //     textColor: '#64748b',
    //     textSize: 18,
    //     textSizeMobile: 16,
    //     textSizeBig: 20,
    //     textWeight: '500',
    //     textFont: '', // Will use globalSmallFont
        
    //     // Line & Icon Styling
    //     lineColor: '#e2e8f0',
    //     lineHeight: 60,
    //     lineWidth: 2,
        
    //     iconSize: 40,
    //     iconColor: '#667eea',
        
    //     // Background Settings
    //     backgroundColor: '#ffffff',
    //     backgroundImage: '',
    //     backgroundImageOpacity: 10, // Prozent-Wert für neue ImageContainer
    //     imageEffect: 'none', // none|blur|grayscale|top-fade
        
    //     // Foreground Image (left bottom corner)
    //     foregroundImage: '',
    //     showForegroundImage: false,
    //     foregroundImageWidth: 300,
    //     foregroundImageHeight: 400,
    //     foregroundImageBorderRadius: 12,
    //     foregroundImagePosition: 'left-bottom', // left-bottom|left-top|right-bottom|right-top
        
    //     // Layout Settings
    //     achievementLayout: 'classic-horizontal', // Layout style
    //     achievementStyle: 'classic-with-line', // Container style
    //     containerSpacing: 80, // Space between achievement containers
    //     containerSpacingMobile: 40,
        
    //     // Standard Widget Properties
    //     marginTop: 0,
    //     marginBottom: 40,
    //     borderRadius: 0,
    //     border: false,
    //     borderColor: '#CCCCCC',
        
    //     // 🚀 STANDARD LAYOUT PROPERTIES (Revolutionary Layout System)
    //     // Spacing - Desktop
    //     paddingTop: 80,
    //     paddingBottom: 80,
        
    //     // Spacing - Mobile
    //     paddingTopMobile: 60,
    //     paddingBottomMobile: 60,
        
    //     // Height Dimensions - Desktop
    //     height: 'auto',
    //     minHeight: 0,
        
    //     // Height Dimensions - Mobile
    //     heightMobile: 'auto',
    //     minHeightMobile: 0,
        
    //     // Widget Meta (REQUIRED)
    //     imagePreview: '/img/achievements_banner.jpg',
    //     id: '',
    //     type: 'AchievementsBanner',
    //     name: 'Achievements Banner',
    //     position: '20',
    //     isSelected: false,
    //     cat1: 'Fancy',
    //     cat2: 'Basic',
        
    //     // AI Integration (REQUIRED)
    //     aiInfo: aiWidgetInfos.achievementsBanner
    // },

    // // Product Widgets (Digital Products & Courses Only)
    // productInfoWidget: {
    //     // Product Connection
    //     productId: '', // Wird dynamisch gesetzt
        
    //     // Display Settings - Core Info
    //     showTitle: true,
    //     showDescription: true,
    //     showSubtype: true, // E-Book, Template, Online Course, etc.
    //     showPrice: true,
    //     showAccessDuration: true, // Lifetime access, 30 days, etc.
    //     showMaxPurchases: true, // Limited availability
    //     showButton: true,
        
    //     // Custom Features (3-5 user-definierte Features)
    //     showCustomFeatures: true,
    //     customFeatures: [
    //         { text: 'Bonus materials included' },
    //         { text: '24/7 customer support' },
    //         { text: 'Money-back guarantee' }
    //     ],
    //     featuresIconColor: '#10b981', // Background color for feature icons
        
    //     // Background Image (like SimplisticQuote)
    //     backgroundImage: '/img/money-mindset.jpg', // Background image with effects
    //     backgroundImageOpacity: 10, // Prozent-Wert für neue ImageContainer
    //     imageEffect: 'blur', // none|blur|grayscale|top-fade|etc.
        
    //     // Product Image
    //     productImage: '/img/money-mindset.jpg', // Additional product image
    //     showProductImage: true,
    //     productImageMode: 'banner', // normal|banner
    //     productImagePosition: 'right', // right|left|top|bottom|center
    //     productImageShape: 'rectangle', // rectangle|rounded|circle
    //     productImageAlignment: 'center', // top|center|bottom (for vertical alignment)
        
    //     // Normal Mode Settings
    //     productImageWidth: 300, // Width in pixels
    //     productImageHeight: 200, // Height in pixels
    //     productImageBorderRadius: 12,
        
    //     // Banner Mode Settings (40% width, full height)
    //     bannerImageWidth: 40, // Percentage of container width
    //     bannerImageAlignment: 'right', // right|left
        
    //     // Button Configuration
    //     buttonText: 'Get Instant Access',
    //     buttonLink: '',
        
    //     // 🚀 TEXT REFACTORING 2025 - Show/Hide Toggles für Text-Felder
    //     showButtonText: true,
    //     showButtonLink: true,
    //     buttonColor: '#667eea',
    //     buttonTextColor: '#ffffff',
    //     buttonBorderRadius: 8,
    //     buttonPaddingY: 16,
    //     buttonPaddingX: 32,
        
    //     // Layout Settings
    //     layout: 'card', // hero|card|inline|minimal (changed default to card)
    //     contentAlignment: 'left', // left|center|right
    //     backgroundColor: '#ffffff',
    //     borderRadius: 12,
    //     padding: 40,
    //     marginTop: 0,
    //     marginBottom: 0,
    //     height: 500, // For background image layouts
        
    //     // Border Settings
    //     border: false,
    //     borderColor: '#e2e8f0',
    //     borderWidth: 1,
        
    //     // Text Styling
    //     titleColor: '#1e293b',
    //     titleSize: 36,
    //     titleSizeMobile: 24,
    //     titleSizeBig: 48,
    //     titleWeight: '700',
    //     titleWeightMobile: '700',
    //     titleWeightBig: '700',
        
    //     descriptionColor: '#64748b',
    //     descriptionSize: 16,
    //     descriptionSizeMobile: 18,
    //     descriptionSizeBig: 22,
    //     descriptionWeight: '400',
    //     descriptionWeightMobile: '400',
    //     descriptionWeightBig: '400',
        
    //     priceColor: '#059669',
    //     priceSize: 28,
    //     priceSizeMobile: 24,
    //     priceSizeBig: 32,
    //     priceWeight: '700',
    //     priceWeightMobile: '700',
    //     priceWeightBig: '700',
        
    //     subtypeColor: '#8b5cf6',
    //     subtypeSize: 14,
    //     subtypeWeight: '600',
        
    //     featuresColor: '#374151',
    //     featuresSize: 16,
    //     featuresWeight: '400',
        
    //     // Custom Fonts (optional - falls leer wird globalFont verwendet)
    //     titleFont: '',
    //     descriptionFont: '',
    //     priceFont: '',
    //     buttonFontFamilyFamily: '',
        
    //     // Text Effects (optional)
    //     titleEffect: '',
    //     descriptionEffect: '',
        
    //     // Button Effects
    //     buttonEffect: '',
        
    //     // Shadow
    //     shadow: true,
    //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        
    //     // Widget Meta
    //     imagePreview: '/img/preview-product-info.webp',
    //     id: '',
    //     type: 'ProductInfoWidget',
    //     name: 'Product Info',
    //     position: '1',
    //     isSelected: false,
    //     cat1: 'Product',
    //     cat2: 'Info',
        
    //     // AI Integration
    //     aiInfo: aiWidgetInfos.productInfoWidget
    // },
    heroHeader: {
        // 🚀 NEW DYNAMIC CONTAINER SECTIONS SYSTEM 2025
        containerSections: [
            {
                id: 'container-text-1',
                order: 0,
                visible: true,
                type: 'text',
                
                // Container Styling
                containerPaddingTop: 60,
                containerPaddingRight: 40,
                containerPaddingBottom: 60,
                containerPaddingLeft: 40,
                containerPaddingTopMobile: 40,
                containerPaddingRightMobile: 20,
                containerPaddingBottomMobile: 40,
                containerPaddingLeftMobile: 20,
                
                containerMarginTop: 0,
                containerMarginRight: 0,
                containerMarginBottom: 0,
                containerMarginLeft: 0,
                containerMarginTopMobile: 0,
                containerMarginRightMobile: 0,
                containerMarginBottomMobile: 0,
                containerMarginLeftMobile: 0,
                
                containerBackgroundColor: 'transparent',
                containerBackgroundGradientEnabled: false,
                containerBackgroundGradientColor1: '#667eea',
                containerBackgroundGradientColor2: '#764ba2',
                containerBackgroundImage: '',
                containerBackgroundImageSize: 'cover',
                containerBackgroundImagePosition: 'center',
                containerBackgroundImageOpacity: 100,
                
                containerBorderEnabled: false,
                containerBorderWidth: 1,
                containerBorderColor: '#cccccc',
                containerBorderRadius: 0,
                containerBorderRadiusMobile: 0,
                containerShadowEnabled: false,
                containerShadowIntensity: 15,
                containerShadowDistance: 8,
                containerShadowOpacity: 25,
                
                containerContentAlignmentVertical: 'center',
                containerContentAlignmentHorizontal: 'flex-start',
                
                containerWidth: 'auto',
                containerHeight: 'auto',
                containerWidthMobile: 'auto',
                containerHeightMobile: 'auto',
                
                // Content Elements in diesem Container
                contentElements: [
            {
                id: 'desc-1',
                type: 'text',
                order: 0,
                visible: true,
                elementType: 'description',
                
                // Content
                content: 'Du möchtest dein Business in <strong>Leichtigkeit & in deiner Femininen Energie</strong> führen? Dann hab ich genau das richtige für dich...',
                
                // Styling (Desktop)
                fontSize: 14,
                fontWeight: '400',
                fontFamily: '',
                color: '#333333',
                lineHeight: 1.6,
                letterSpacing: 0,
                textAlign: 'left',
                maxWidth: 500,
                
                // Margins (Desktop)
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                
                // Styling (Mobile)
                fontSizeMobile: 12,
                fontWeightMobile: '400',
                lineHeightMobile: 1.6,
                letterSpacingMobile: 0,
                textAlignMobile: 'left',
                
                // Margins (Mobile)
                marginTopMobile: 0,
                marginRightMobile: 0,
                marginBottomMobile: 0,
                marginLeftMobile: 0,
                
                // Effects
                textEffect: '',
                
                // 🎬 Animation Properties (2025)
                animationEnabled: false,
                animationType: 'fadeInUp',
                animationSpeed: 'normal',
                triggerAnimation: null,
                
                // Element-specific
                placeholder: 'Enter description...'
            },
            {
                id: 'title-1',
                type: 'text',
                order: 1,
                visible: true,
                elementType: 'title',
                
                // Content
                content: 'Feminine & Effortless',
                
                // Styling (Desktop)
                fontSize: 48,
                fontWeight: '700',
                fontFamily: '',
                color: '#333333',
                lineHeight: 1.2,
                letterSpacing: 0,
                textAlign: 'left',
                maxWidth: 600,
                
                // Margins (Desktop)
                marginTop: 0,
                marginRight: 0,
                marginBottom: 16,
                marginLeft: 0,
                
                // Styling (Mobile)
                fontSizeMobile: 32,
                fontWeightMobile: '700',
                lineHeightMobile: 1.2,
                letterSpacingMobile: 0,
                textAlignMobile: 'left',
                
                // Margins (Mobile)
                marginTopMobile: 0,
                marginRightMobile: 0,
                marginBottomMobile: 0,
                marginLeftMobile: 0,
                
                // Effects
                textEffect: '',
                
                // 🎬 Animation Properties (2025)
                animationEnabled: false,
                animationType: 'fadeInUp',
                animationSpeed: 'normal',
                triggerAnimation: null,
                
                // Element-specific
                placeholder: 'Enter your title...'
            },
            {
                id: 'subtitle-1',
                type: 'text',
                order: 2,
                visible: true,
                elementType: 'subtitle',
                
                // Content
                content: 'Deine High-Energy Audio direkt aufs Ohr.',
                
                // Styling (Desktop)
                fontSize: 24,
                fontWeight: '400',
                fontFamily: '',
                color: '#666666',
                lineHeight: 1.4,
                letterSpacing: 0,
                textAlign: 'left',
                maxWidth: 550,
                
                // Margins (Desktop)
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                
                // Styling (Mobile)
                fontSizeMobile: 20,
                fontWeightMobile: '400',
                lineHeightMobile: 1.4,
                letterSpacingMobile: 0,
                textAlignMobile: 'left',
                
                // Margins (Mobile)
                marginTopMobile: 0,
                marginRightMobile: 0,
                marginBottomMobile: 0,
                marginLeftMobile: 0,
                
                // Effects
                textEffect: '',
                
                // 🎬 Animation Properties (2025)
                animationEnabled: false,
                animationType: 'fadeInUp',
                animationSpeed: 'normal',
                triggerAnimation: null,
                
                // Element-specific
                placeholder: 'Enter subtitle...'
            },
            {
                id: 'additional-1',
                type: 'text',
                order: 3,
                visible: true,
                elementType: 'additional',
                
                // Content
                content: 'Für mehr Weiblichkeit & Fülle in deinem Business.',
                
                // Styling (Desktop)
                fontSize: 18,
                fontWeight: '500',
                fontFamily: '',
                color: '#888888',
                lineHeight: 1.6,
                letterSpacing: 0,
                textAlign: 'left',
                maxWidth: 450,
                
                // Margins (Desktop)
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                
                // Styling (Mobile)
                fontSizeMobile: 16,
                fontWeightMobile: '500',
                lineHeightMobile: 1.6,
                letterSpacingMobile: 0,
                textAlignMobile: 'left',
                
                // Margins (Mobile)
                marginTopMobile: 0,
                marginRightMobile: 0,
                marginBottomMobile: 0,
                marginLeftMobile: 0,
                
                // Effects
                textEffect: '',
                
                // 🎬 Animation Properties (2025)
                animationEnabled: false,
                animationType: 'fadeInUp',
                animationSpeed: 'normal',
                triggerAnimation: null,
                
                // Element-specific
                placeholder: 'Enter additional text...'
            },
            {
                id: 'button-1',
                type: 'button',
                order: 4,
                visible: true,
                
                // Button Content
                buttonText: 'Hol dir hier deine Audio',
                buttonLink: '',
                
                // Typography
                buttonTextSize: 18,
                buttonTextSizeMobile: 16,
                buttonTextWeight: '600',
                buttonTextWeightMobile: '600',
                buttonFontFamily: '',
                
                // Dimensions
                buttonWidth: 200,
                buttonWidthDesktop: 200,
                buttonWidthMobile: 100,
                buttonMaxWidth: 300,
                buttonMaxWidthMobile: 280,
                buttonHeight: 50,
                buttonHeightMobile: 48,
                buttonBorderRadius: 8,
                buttonBorderRadiusMobile: 8,
                
                // Colors & Styling
                buttonColor: '#5C80BC',
                buttonTextColor: '#FFFFFF',
                
                // Gradient System
                buttonGradientEnabled: false,
                buttonGradientColor1: '#667eea',
                buttonGradientColor2: '#764ba2',
                buttonGradientAnimation: false,
                
                // Shadow System
                buttonShadowEnabled: false,
                buttonShadowIntensity: 15,
                buttonShadowDistance: 8,
                buttonShadowOpacity: 25,
                buttonShadowColor: '#000000',
                
                // Border System
                buttonBorderEnabled: false,
                buttonBorderWidth: 2,
                buttonBorderColor: '#5C80BC',
                
                // Button Animations (Hover Effects)
                buttonAnimationsEnabled: false,
                buttonAnimationType: 'gentle-pulse',
                buttonAnimationSpeed: 2000,
                
                // 🎬 Element Entrance Animations (2025)
                animationEnabled: false,
                animationType: 'fadeInUp',
                animationSpeed: 'normal',
                triggerAnimation: null,
                
                // Margins - ✅ Alle auf 0 für sauberes Default-Layout
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0,
                marginTopMobile: 0,
                marginBottomMobile: 0,
                marginLeftMobile: 0,
                marginRightMobile: 0,
                
                // Effects
                buttonEffect: ''
            }
                ]
            },
            {
                id: 'container-image-1',
                order: 1,
                visible: true,
                type: 'image',
                
                // Container Styling
                containerPaddingTop: 0,
                containerPaddingRight: 0,
                containerPaddingBottom: 0,
                containerPaddingLeft: 0,
                containerPaddingTopMobile: 0,
                containerPaddingRightMobile: 0,
                containerPaddingBottomMobile: 0,
                containerPaddingLeftMobile: 0,
                
                containerMarginTop: 0,
                containerMarginRight: 0,
                containerMarginBottom: 0,
                containerMarginLeft: 0,
                containerMarginTopMobile: 0,
                containerMarginRightMobile: 0,
                containerMarginBottomMobile: 0,
                containerMarginLeftMobile: 0,
                
                containerBackgroundColor: 'transparent',
                containerBackgroundGradientEnabled: false,
                containerBackgroundGradientColor1: '#667eea',
                containerBackgroundGradientColor2: '#764ba2',
                containerBackgroundImage: '/img/holistic_lady.jpg',
                containerBackgroundImageSize: 'cover',
                containerBackgroundImagePosition: 'center',
                containerBackgroundImageOpacity: 100,
                
                containerBorderEnabled: false,
                containerBorderWidth: 1,
                containerBorderColor: '#cccccc',
                containerBorderRadius: 0,
                containerBorderRadiusMobile: 0,
                containerShadowEnabled: false,
                containerShadowIntensity: 15,
                containerShadowDistance: 8,
                containerShadowOpacity: 25,
                
                containerContentAlignmentVertical: 'center',
                containerContentAlignmentHorizontal: 'center',
                
                containerWidth: 'auto',
                containerHeight: 'auto',
                containerWidthMobile: 'auto',
                containerHeightMobile: 'auto',
                
                // Empty content elements (Image als Background)
                contentElements: []
            }
        ],
        
        // Grid Layout Settings
        gridLayout: 'grid-cols-2-equal', // Default: 2 Columns Equal (50/50)
        
        // ⚠️ LEGACY: Hero Image & Logo (für Backward Compatibility)
        heroImage: '/img/holistic_lady.jpg',
        showHeroImage: true,
        heroImageWidth: 50,
        heroImageHeight: 100,
        heroImageOpacity: 100,
        heroImagePosition: 'side',
        logoImage: '',
        showLogo: true,
        logoWidth: 120,
        logoHeight: 60,
        logoPosition: 'top-right',
        logoPositionMobile: 'top-center',  // ✅ MOBILE LOGO POSITION
        logoInvert: false,                 // ✅ DESKTOP LOGO INVERT
        logoInvertMobile: false,           // ✅ MOBILE LOGO INVERT
        showLogoMobile: true,              // ✅ MOBILE LOGO VISIBILITY
        logoMargin: 20,
        logoCornerDistance: 20,
        
        // Background Image Settings
        backgroundImage: '',
        showBackgroundImage: false,
        backgroundImageOpacity: 50,
        backgroundImageSize: 'cover',
        backgroundImagePosition: 'center',
        backgroundImageEffect: 'none',
        backgroundImageBlur: 0,
        
        // ⚠️ LEGACY FIELDS - Kept for Backward Compatibility
        // These will be migrated to contentElements automatically
        // Content Text - ✅ RICH TEXT mit HTML-Formatierung
        descriptionText: 'Du möchtest dein Business in <strong>Leichtigkeit & in deiner Femininen Energie</strong> führen? Dann hab ich genau das richtige für dich...',
        descriptionMaxWidth: 500,            // Max Width für Description Text (px) - Standard 500px
        descriptionWidth: 500,               // Width für Description Text (px) - Standard 500px
        titleText: 'Feminine & Effortless',
        titleWidth: 600,                     // Width für Title Text (px) - Standard 600px
        titleMarginTop: 0,                   // Margin Top für Title (px) - Standard 0px
        titleMarginBottom: 16,               // Margin Bottom für Title (px) - Standard 16px
        // ✅ HIGHLIGHT-SYSTEM für titleText
        titleHighlightWords: 'Feminine', // Komma-getrennte Wörter zum Highlighten
        titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
        titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
        titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
        titleHighlightEffect: '', // Text-Effect für highlighted Wörter
        titleHighlightSize: 48, // Desktop Font-Größe (gleich wie titleSize)
        titleHighlightSizeMobile: 36, // Mobile Font-Größe (gleich wie titleSizeMobile)
        titleHighlightSizeBig: 56, // Big Screen Font-Größe (gleich wie titleSizeBig)
        titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
        titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
        subtitleText: 'Deine High-Energy Audio direkt aufs Ohr.',
        subtitleWidth: 550,                  // Width für Subtitle Text (px) - Standard 550px
        additionalText: 'Für mehr Weiblichkeit & Fülle in deinem Business.',
        additionalWidth: 450,                // Width für Additional Text (px) - Standard 450px
        
        // Custom Fonts (optional - falls leer wird globalFont verwendet)
        descriptionFont: '',
        titleFont: '',
        subtitleFont: '',
        additionalFont: '',
        buttonFontFamilyFamily: '',
        
        // Text Effects (optional - falls leer wird kein Effekt angewendet)
        descriptionEffect: '',
        titleEffect: '',
        subtitleEffect: '',
        additionalEffect: '',
        
        // Button Effects (optional - kombiniert Background + Text Effekte)
        buttonEffect: '',
        
        // Text Colors & Sizes (AI-Colors haben Priorität!)
        // descriptionColor, titleColor, subtitleColor, additionalColor
        // werden jetzt dynamisch von AI-Design-System gesetzt!
        descriptionSize: 14,
        descriptionSizeMobile: 12,
        descriptionSizeBig: 14,
        descriptionWeight: '400',
        descriptionWeightMobile: '400',
        descriptionWeightBig: '400',
        
        titleSize: 48,
        titleSizeMobile: 32,
        titleSizeBig: 56,
        titleWeight: '700',
        titleWeightMobile: '700',
        titleWeightBig: '700',
        
        subtitleSize: 24,
        subtitleSizeMobile: 20,
        subtitleSizeBig: 28,
        subtitleWeight: '400',
        subtitleWeightMobile: '400',
        subtitleWeightBig: '400',
        
        additionalSize: 18,
        additionalSizeMobile: 16,
        additionalSizeBig: 20,
        additionalWeight: '500',
        additionalWeightMobile: '500',
        additionalWeightBig: '500',
        
        // Button Content
        buttonText: 'Hol dir hier deine Audio',
        buttonLink: '',
        
        // 🚀 RESPONSIVE BUTTON STYLING - Desktop/Mobile
        // Typography
        buttonTextSize: 18,                    // Desktop Font Size
        buttonTextSizeMobile: 16,              // Mobile Font Size
        buttonTextWeight: '600',               // Desktop Font Weight
        buttonTextWeightMobile: '600',         // Mobile Font Weight
        
        // Dimensions - ✅ VEREINFACHTE BUTTON WIDTH LOGIK
        buttonWidth: 200,                      // Desktop Width (px) - Direkte Pixel-Angabe
        buttonWidthDesktop: 200,               // Desktop Width (px) - Neue Property für Klarheit
        buttonWidthMobile: 100,                // Mobile Width (%) - Bleibt Prozent
        buttonMaxWidth: 300,                   // Desktop Max Width (nicht verwendet bei Pixel)
        buttonMaxWidthMobile: 280,             // Mobile Max Width (px) - Für % + maxWidth System
        buttonHeight: 50,                      // Desktop Height px
        buttonHeightMobile: 48,                // Mobile Height px
        buttonBorderRadius: 8,                 // Desktop Border Radius px
        buttonBorderRadiusMobile: 8,           // Mobile Border Radius px
        
        // Colors & Styling
        buttonColor: '#5C80BC',                // Button Background Color
        buttonTextColor: '#FFFFFF',            // Button Text Color
        buttonShadowIntensity: 0,              // Shadow Intensity (0-4)
        buttonBorderWidth: 0,                  // Border Width (0 = no border)
        buttonBorderColor: '#5C80BC',          // Border Color
        
        // Gradient System
        buttonGradientEnabled: false,          // Enable Gradient Background
        buttonGradientColor1: '#667eea',       // Gradient Color 1
        buttonGradientColor2: '#764ba2',       // Gradient Color 2
        buttonGradientAnimation: false,        // Enable Gradient Animation
        
        // Shadow System
        buttonShadowEnabled: false,            // Enable Button Shadow
        buttonShadowIntensity: 15,             // Shadow Blur (5-50px)
        buttonShadowDistance: 8,               // Shadow Distance (0-30px)
        buttonShadowOpacity: 25,               // Shadow Opacity (5-80%)
        buttonShadowColor: '#000000',          // Shadow Color
        
        // Border System
        buttonBorderEnabled: false,            // Enable Button Border
        buttonBorderWidth: 2,                  // Border Width (1-8px)
        buttonBorderColor: '#5C80BC',          // Border Color
        
        // Button Animations System
        buttonAnimationsEnabled: false,        // Enable Button Animations
        buttonAnimationType: 'gentle-pulse',   // Animation Type (none, gentle-pulse, soft-glow, subtle-float, gentle-breathe, soft-shimmer)
        buttonAnimationSpeed: 2000,            // Animation Speed (800-4000ms)
        
        // Layout (AI-Colors haben Priorität!)
        // backgroundColor, leftBackgroundColor werden jetzt dynamisch von AI-Design-System gesetzt!
        height: 'auto',            // Standard Desktop-Height (reduziert von 1050px)
        heightMobile: 1100,     // Standard Mobile-Height (1100px)
        paddingTop: 0,         // Standard Padding
        paddingBottom: 0,      // Standard Padding
        paddingLeft: 0,        // Standard Padding Left
        paddingRight: 0,       // Standard Padding Right
        borderRadius: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,         // Standard Margin Left
        marginRight: 0,        // Standard Margin Right
        border: false,
        borderColor: '#CCCCCC',
        
        // Layout System (New 2025 Layout System)
        layoutType: 'classic-split', // Default Layout
        
        // Layout Settings (New 2025 Layout Toolbar)
        flexDirection: 'row',          // row | column | row-reverse | column-reverse
        childDistribution: '50-50',    // '50-50' | '60-40' | '70-30' | '40-60' | '30-70' | 'auto'
        
        // Text Alignment System
        textAlignment: 'left', // left | center | right - Ausrichtung für Text und Button
        
        // Widget Meta
        imagePreview: '/img/hero_header.jpg',
        id: '',
        type: 'HeroHeader',
        name: 'Hero Header',
        position: '1',
        isSelected: false,
        cat1: 'Fancy',
        cat2: 'Image',
        
        // Animation Settings (2025 Animation System)
        enableAnimations: false,
        animationType: 'fadeInUp',
        animationDuration: 600,
        animationDelay: 200,
        triggerAnimation: null,
        
        // AI Integration
        aiInfo: aiWidgetInfos.heroHeader
    },
      

  


    


   


//     hiWidget: {
//       // Profile Image
//       profileImage: '/img/laura.webp',
//       profileImageSize: 200,     // ✅ ORDENTLICHE STANDARD-GRÖSSE
//       profileImageShape: 'organic-1',
//       profileImageBorder: false, // ✅ KEIN FRAME ALS STANDARD
//       profileImageBorderWidth: 0, // ✅ KEIN BORDER-WIDTH
//       profileImageBorderColor: '#FFFFFF',
//       profileImageShadow: false, // ✅ KEIN SHADOW ALS STANDARD
//       imageOpacity: 100,  // ✅ NEUE IMAGE OPACITY CONTROL
      
//       // ✅ FULL-HEIGHT IMAGE WIDTH CONTROLS (Prozent-basiert)
//       fullHeightImageWidth: 35,        // Desktop: 35% der Widget-Breite
//       fullHeightImageWidthMobile: 40,  // Mobile: 40% der Widget-Breite
      
//       // ✅ IMAGE MARGIN TO EDGE (Side-by-Side Layouts)
//       imageMarginToEdge: 40,           // Desktop: Margin zwischen Image und Widget-Rand
      
//       // Content Text
//       greetingText: 'Hi, I\'m Laura!',
//       titleText: 'I\'m a podcaster, best-selling author, business owner, life coach, speaker, visionary and mother-of-two.',
//       descriptionText: 'My life\'s purpose is to help you discover your true self and support you in creating a life that you won\'t need a break from - because you\'re so in love with it!',
      
//       // ✅ HIGHLIGHT-SYSTEM für titleText
//       titleHighlightWords: '', // Komma-getrennte Wörter zum Highlighten
//       titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//       titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//       titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
//       titleHighlightEffect: '', // Text-Effect für highlighted Wörter
//       titleHighlightSize: 24, // Desktop Font-Größe (gleich wie titleSize)
//       titleHighlightSizeMobile: 20, // Mobile Font-Größe (gleich wie titleSizeMobile)
//       titleHighlightSizeBig: 28, // Big Screen Font-Größe (gleich wie titleSizeBig)
//       titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
//       titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
      
//       // Custom Fonts (optional - falls leer wird globalFont verwendet)
//       greetingFont: '', // Primary Font (globalBigFont)
//       titleFont: '', // Secondary Font (globalSmallFont)
//       descriptionFont: '', // Secondary Font (globalSmallFont)
//       buttonFontFamilyFamily: '',
      
//       // Text Effects (optional - falls leer wird kein Effekt angewendet)
//       greetingEffect: '',
//       titleEffect: '',
//       descriptionEffect: '',
      
//       // Button Effects (optional - kombiniert Background + Text Effekte)
//       buttonEffect: '',
      
//       // Text Colors & Sizes
//       greetingColor: '#5C80BC',
//       greetingSize: 48,
//       greetingSizeMobile: 36,
//       greetingSizeBig: 56,
//       greetingWeight: '700',
//       greetingWeightMobile: '700',
//       greetingWeightBig: '700',
      
//       titleColor: '#30323D',
//       titleSize: 24,
//       titleSizeMobile: 20,
//       titleSizeBig: 28,
//       titleWeight: '600',
//       titleWeightMobile: '600',
//       titleWeightBig: '600',
      
//       descriptionColor: '#666666',
//       descriptionSize: 18,
//       descriptionSizeMobile: 16,
//       descriptionSizeBig: 20,
//       descriptionWeight: '400',
//       descriptionWeightMobile: '400',
//       descriptionWeightBig: '400',
      
//       // Button Content
//       buttonText: 'More about me',
//       buttonLink: '',
      
//       // 🚀 RESPONSIVE BUTTON STYLING - Desktop/Mobile
//       // Typography
//       buttonTextSize: 18,                    // Desktop Font Size
//       buttonTextSizeMobile: 16,              // Mobile Font Size
//       buttonTextWeight: '600',               // Desktop Font Weight
//       buttonTextWeightMobile: '600',         // Mobile Font Weight
      
//       // Dimensions
//       buttonWidth: 300,                      // Desktop Width px
//       buttonWidthMobile: 280,                // Mobile Width px
//       buttonHeight: 50,                      // Desktop Height px
//       buttonHeightMobile: 48,                // Mobile Height px
//       buttonBorderRadius: 8,                 // Desktop Border Radius px
//       buttonBorderRadiusMobile: 8,           // Mobile Border Radius px
      
//       // Colors & Styling
//       buttonColor: '#5C80BC',                // Button Background Color
//       buttonTextColor: '#FFFFFF',            // Button Text Color
      
//       // Gradient System
//       buttonGradientEnabled: false,          // Enable Gradient Background
//       buttonGradientColor1: '#667eea',       // Gradient Color 1
//       buttonGradientColor2: '#764ba2',       // Gradient Color 2
//       buttonGradientAnimation: false,        // Enable Gradient Animation
      
//       // Shadow System
//       buttonShadowEnabled: false,            // Enable Button Shadow
//       buttonShadowIntensity: 15,             // Shadow Blur (5-50px)
//       buttonShadowDistance: 8,               // Shadow Distance (0-30px)
//       buttonShadowOpacity: 25,               // Shadow Opacity (5-80%)
//       buttonShadowColor: '#000000',          // Shadow Color
      
//       // Border System
//       buttonBorderEnabled: false,            // Enable Button Border
//       buttonBorderWidth: 2,                  // Border Width (1-8px)
//       buttonBorderColor: '#5C80BC',          // Border Color
      
//       // Button Animations System
//       buttonAnimationsEnabled: false,        // Enable Button Animations
//       buttonAnimationType: 'gentle-pulse',   // Animation Type
//       buttonAnimationSpeed: 2000,            // Animation Speed (800-4000ms)
      
//       // Layout
//       backgroundColor: '#FFF8DC',
//       maxWidth: 1200,
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // ✅ NEW LAYOUT SYSTEM 2025 - RESPONSIVE LAYOUT PROPERTIES
//       height: 'auto',         // ✅ AUTO HEIGHT ALS STANDARD
//       heightMobile: 'auto',   // ✅ AUTO HEIGHT MOBILE ALS STANDARD
//       paddingTop: 80,         // ✅ REDUZIERTES DESKTOP PADDING
//       paddingTopMobile: 40,   // Mobile Padding
//       paddingBottom: 80,      // ✅ REDUZIERTES DESKTOP PADDING
//       paddingBottomMobile: 40, // Mobile Padding
//       marginTop: 0,
//       marginBottom: 40,
//       borderRadius: 0,
      
//       // Layout System
//       layoutType: 'classic-profile', // Default Layout
      
//       // Content Spacing Settings
//       contentSpacing: 40,        // Inner spacing around content (desktop)
//       contentSpacingMobile: 20,  // Inner spacing around content (mobile)
      
//       // ✅ NEUE LAYOUT MANIPULATION CONTROLS
//       // Text Layout Controls
//       textMaxWidth: 600,         // Desktop Text Max Width
//       textMaxWidthMobile: 400,   // Mobile Text Max Width
//       imageTextGap: 40,          // Desktop Gap zwischen Image und Text
//       imageTextGapMobile: 20,    // Mobile Gap zwischen Image und Text
//       textVerticalAlign: 'center', // Vertical Alignment: 'flex-start', 'center', 'flex-end'
      
//       // Flip & Order Controls
//       desktopFlipSides: false,   // Desktop: Image/Text Seiten tauschen
//       mobileFlipSides: false,    // Mobile: Image/Text Reihenfolge tauschen
//       mobileStackOrder: 'image-first', // Mobile Stack: 'image-first', 'text-first'
      
//       // Advanced Spacing Controls
//       textLineHeight: 1.6,       // Line Height für bessere Lesbarkeit
//       elementSpacing: 20,        // Desktop: Abstand zwischen Text-Elementen
//       elementSpacingMobile: 15,  // Mobile: Abstand zwischen Text-Elementen
      
//       // Widget Meta
//       imagePreview: '/img/hi_widget.jpg',
//       id: '',
//       type: 'HiWidget',
//       name: 'Hi Widget',
//       position: '23',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Image',
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.hiWidget
//     },

//     videoTeaser: {
//       // Header Image
//       showHeaderImage: true,
//       headerImage: '/img/holy_sunset.jpg',
//       headerImageHeight: 120,
//       headerSpacing: 40,
      
//       // Decoration Image (Design Element)
//       showDecorationImage: false,
//       decorationImage: '/img/gold_glitter.png',
//       decorationImageSize: 320,        // ✅ NEW DEFAULT: 320px
//       decorationImagePositionX: 80,    // Position horizontal (0-100%)
//       decorationImagePositionY: 15,    // ✅ NEW DEFAULT: 15%
//       decorationImageOpacity: 75,      // ✅ NEW DEFAULT: 75%
      
//       // Icon
//       iconImage: '/img/abstract.svg',
//       iconHeight: 60,
      
//       // Content Text - ✅ RICH TEXT mit HTML-Formatierung
//       richText: '<strong>Reclaim Your Energy</strong><br>The Power Talk',
//       richTextMaxWidth: 600,               // Max Width für Rich Text (px) - Standard 600px
//       descriptionText: 'You give so much of your <strong>energy</strong> to others — now it\'s time to bring it back to you! This 10-minute guided Power Talk will help you release what no longer serves you and realign with your <strong>true essence</strong>.',
//       descriptionMaxWidth: 500,            // Max Width für Description Text (px) - Standard 500px
      
//       // ✅ HIGHLIGHT-SYSTEM für richText (Titel) - HTML-Content Support
//       richTextHighlightWords: 'Energy, Power', // Komma-getrennte Wörter zum Highlighten
//       richTextHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//       richTextHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//       richTextHighlightWeight: '800', // Font-Weight für highlighted Wörter
//       richTextHighlightWeightMobile: '800', // Mobile Font-Weight für highlighted Wörter
//       richTextHighlightWeightBig: '800', // Big Screen Font-Weight für highlighted Wörter
//       richTextHighlightEffect: '', // Text-Effect für highlighted Wörter
//       richTextHighlightSize: 28, // Desktop Font-Größe (gleich wie richTextSize)
//       richTextHighlightSizeMobile: 24, // Mobile Font-Größe (gleich wie richTextSizeMobile)
//       richTextHighlightSizeBig: 32, // Big Screen Font-Größe (gleich wie richTextSizeBig)
//       richTextHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
//       richTextHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
      
//       // YouTube Video
//       youtubeUrl: 'https://www.youtube.com/watch?v=HkB4dev0zik',
//       videoBorderRadius: 12,
//       videoContainerWidth: 45,
      
//       // Custom Fonts (optional - falls leer wird globalFont verwendet)
//       richTextFont: '',
//       descriptionFont: '',
//       buttonFontFamilyFamily: '',
      
//       // Text Effects (optional - falls leer wird kein Effekt angewendet)
//       richTextEffect: '',
//       descriptionEffect: '',
//       buttonEffect: '',
      
//       // Text Colors & Sizes
//       richTextColor: '#2c3e50',
//       richTextSize: 28,
//       richTextSizeMobile: 24,
//       richTextSizeBig: 32,
//       richTextWeight: '600',
//       richTextWeightMobile: '600',
//       richTextWeightBig: '600',
      
//       descriptionColor: '#666666',
//       descriptionSize: 16,
//       descriptionSizeMobile: 14,
//       descriptionSizeBig: 18,
//       descriptionWeight: '400',
      
//       // Button Content
//       buttonText: 'Download audio file',
//       buttonLink: '',
      
//       // Button Styling
//       buttonTextSize: 18,
//       buttonTextSizeMobile: 16,
//       buttonTextWeight: '600',
//       buttonTextWeightMobile: '600',
//       buttonColor: '#5C80BC',
//       buttonTextColor: '#FFFFFF',
//       buttonBorderRadius: 8,
//       buttonPaddingY: 14,
//       buttonPaddingX: 28,
      
//       // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//       height: 'auto',              // ✅ Auto height - passt sich an Inhalt an
//       heightMobile: 'auto',        // ✅ Auto height mobile - passt sich an Inhalt an
//       paddingTop: 60,              // Desktop Padding
//       paddingTopMobile: 40,        // Mobile Padding
//       paddingBottom: 60,           // Desktop Padding
//       paddingBottomMobile: 40,     // Mobile Padding
//       marginTop: 0,
//       marginBottom: 40,
//       borderRadius: 0,
      
//       // Layout System
//       layoutType: 'classic-video-right', // Default Layout
      
//       // Text Alignment & Responsive
//       textAlignment: 'left',
//       textAlignmentMobile: 'center',
      
//       // Widget-specific Properties
//       contentSpacing: 60,
//       contentSpacingMobile: 30,        // ✅ Mobile Content Spacing
//       videoGap: 40,                    // Gap zwischen Video und Text in centered layouts
//       videoGapMobile: 30,              // ✅ Mobile Video Gap
      
//       // ✅ TEXT WIDTH CONTROLS
//       richTextMaxWidth: 600,           // Maximum width of the rich text container (px)
//       descriptionMaxWidth: 500,        // Maximum width of the description text container (px)
      
//       // Video Properties
//       videoBorderRadiusMobile: 8,      // ✅ Mobile Video Border Radius
//       videoContainerWidthMobile: 80,   // ✅ Mobile Video Container Width
      
//       // Image Properties Mobile
//       headerImageHeightMobile: 100,    // ✅ Mobile Header Image Height
//       headerSpacingMobile: 30,         // ✅ Mobile Header Spacing
//       iconHeightMobile: 50,            // ✅ Mobile Icon Height
      
//       // Decoration Image Mobile
//       decorationImageSizeMobile: 280,  // ✅ Mobile Decoration Image Size (proportional zu 320px)
      
//       // Basic Layout
//       backgroundColor: '#FFF8DC',
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // Visibility Toggles
//       showRichText: true,
//       showDescriptionText: true,
//       showButtonText: true,
//       showHeaderImage: true,
//       showIcon: true,
//       showVideo: true,
      
//       // Second Video Properties (between title and description)
//       showSecondVideo: false,
//       secondVideoUrl: '',
//       secondVideoWidth: 60,
//       secondVideoWidthMobile: 80,
//       secondVideoBorderRadius: 8,
//       secondVideoBorderRadiusMobile: 6,
      
//       // Widget Meta (REQUIRED)
//       imagePreview: '/img/video_teaser.jpg',
//       id: '',
//       type: 'VideoTeaser',
//       name: 'Video Teaser',
//       position: '24',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Video',
      
//       // AI Integration (REQUIRED)
//       aiInfo: aiWidgetInfos.videoTeaser
//     },

//     simplicisticHeader: {
//       // Layout - Neues zentriertes Basis-Layout
//       layoutType: 'centered-classic',
      
//       // Background Image
//       backgroundImage: '/img/lady_b.jpg',
//       mobileBackgroundImage: '',
//       backgroundImageOpacity: 100, // Prozent-Wert für neue ImageContainer (Standard: 100%)
//       backgroundImageBlur: 0, // Blur-Intensität (0-10px)
//       imageEffect: '',
      
//       // Icon - Größer für zentriertes Layout
//       iconImage: '/img/salesgod_2.svg',
//       iconHeight: 80,
//       iconShadow: false,
//       iconInvert: false, // Icon invertieren (schwarz/weiß umkehren)
//       showIcon: true,
      
//       // Content Text - Optimiert für zentriertes Layout
//       titleText: 'This is Self Love.',
//       titleHighlightWords: 'Self Love', // Komma-getrennte Wörter zum Highlighten
//       titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//       titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//       titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
//       titleHighlightEffect: '', // Text-Effect für highlighted Wörter
//       titleHighlightSize: 92, // Desktop Font-Größe (gleich wie titleSize)
//       titleHighlightSizeMobile: 48, // Mobile Font-Größe (gleich wie titleSizeMobile)
//       titleHighlightSizeBig: 104, // Big Screen Font-Größe (gleich wie titleSizeBig)
//       titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-20 bis +20px)
//       titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-20 bis +20px)
//       subtitleText: 'Discover three simple actions you can take right now to positively impact your body, mind and life.',
      
//       // Text Shadow
//       textShadow: true,
      
//       // Custom Fonts
//       titleFont: '',
//       subtitleFont: '',
//       buttonFontFamilyFamily: '',
      
//       // Text Effects
//       titleEffect: '',
//       subtitleEffect: '',
//       buttonEffect: '',
      
//       // Text Colors & Sizes - Optimiert für zentriertes Layout
//       titleColor: '#ffffff',
//       titleSize: 92,          // Extra groß für zentrierten Titel
//       titleSizeMobile: 48,     // Groß auch auf Mobile
//       titleSizeBig: 104,        // Noch größer auf großen Screens
//       titleWeight: '800',      // Extra fett
      
//       subtitleColor: '#f0f0f0',
//       subtitleSize: 16,        // Kleiner für dezenten Untertitel
//       subtitleSizeMobile: 14,  // Noch kleiner auf Mobile
//       subtitleSizeBig: 18,     // Etwas größer auf großen Screens
//       subtitleWeight: '300',   // Leichter für dezenten Look
      
//       // Button Content
//       buttonText: 'TAKE THE SELF CARE QUIZ',
//       buttonLink: '',
      
//       // 🚀 RESPONSIVE BUTTON STYLING - Desktop/Mobile
//       // Typography
//       buttonTextSize: 16,                    // Desktop Font Size
//       buttonTextSizeMobile: 14,              // Mobile Font Size
//       buttonTextWeight: '600',               // Desktop Font Weight
//       buttonTextWeightMobile: '600',         // Mobile Font Weight
      
//       // Dimensions
//       buttonWidth: 100,                      // Desktop Width %
//       buttonWidthMobile: 100,                // Mobile Width %
//       buttonMaxWidth: 300,                   // Desktop Max Width px
//       buttonMaxWidthMobile: 300,             // Mobile Max Width px
//       buttonHeight: 50,                      // Desktop Height px
//       buttonHeightMobile: 48,                // Mobile Height px
//       buttonBorderRadius: 4,                 // Desktop Border Radius px
//       buttonBorderRadiusMobile: 4,           // Mobile Border Radius px
      
//       // Colors & Styling - Werden automatisch aus Color Assignments gesetzt
//       // buttonColor: '#D4A574',             // ← Entfernt: Wird aus 'buttons' Assignment gesetzt
//       // buttonTextColor: '#FFFFFF',         // ← Entfernt: Wird aus 'buttonText' Assignment gesetzt
      
//       // Gradient System
//       buttonGradientEnabled: false,          // Enable Gradient Background
//       buttonGradientColor1: '#D4A574',       // Gradient Color 1
//       buttonGradientColor2: '#B8956A',       // Gradient Color 2
//       buttonGradientAnimation: false,        // Enable Gradient Animation
      
//       // Shadow System
//       buttonShadowEnabled: false,            // Enable Button Shadow
//       buttonShadowIntensity: 15,             // Shadow Blur (5-50px)
//       buttonShadowDistance: 8,               // Shadow Distance (0-30px)
//       buttonShadowOpacity: 25,               // Shadow Opacity (5-80%)
//       buttonShadowColor: '#000000',          // Shadow Color
      
//       // Border System
//       buttonBorderEnabled: false,            // Enable Button Border
//       buttonBorderWidth: 2,                  // Border Width (1-8px)
//       buttonBorderColor: '#D4A574',          // Border Color
      
//       // Button Animations System
//       buttonAnimationsEnabled: false,        // Enable Button Animations
//       buttonAnimationType: 'gentle-pulse',   // Animation Type
//       buttonAnimationSpeed: 2000,            // Animation Speed (800-4000ms)
      
//       // Layout
//       backgroundColor: '#D4A574',
//       height: 670,
//       borderRadius: 0,
//       marginTop: 0,
//       marginBottom: 0,
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // 🚀 STANDARD LAYOUT PROPERTIES - Revolutionary Layout System
      
//       // Spacing - Desktop
//       paddingTop: 0,
//       paddingBottom: 0,
//       marginTop: 0,
//       marginBottom: 40,
      
//       // Spacing - Mobile
//       paddingTopMobile: 20,
//       paddingBottomMobile: 20,
//       marginTopMobile: 0,
//       marginBottomMobile: 20,
      
//       // Height Dimensions - Desktop (Größer für zentriertes Layout)
//       height: 700,
//       minHeight: 500,
//       // maxHeight: '', // Optional - nur setzen wenn gewünscht
      
//       // Height Dimensions - Mobile
//       heightMobile: 1200,
//       minHeightMobile: 400,
//       // maxHeightMobile: '', // Optional - nur setzen wenn gewünscht
      
//       // Text Alignment - Responsive (Zentriert für neues Layout)
//       textAlignment: 'center',
//       textAlignmentMobile: 'center',
      
//       // Visibility Toggles
//       showTitleText: true,
//       showSubtitleText: true,
//       showButtonText: true,
      
//       // Animation Settings
//       enableAnimations: false,
//       animationType: 'fadeInUp',
//       animationDuration: 600,
//       animationDelay: 200,
//       triggerAnimation: 0,
      
//       // Widget Meta
//       imagePreview: '/img/simply_header.jpg',
//       id: '',
//       type: 'SimplisticHeader',
//       name: 'Simplistic Header',
//       position: '25',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Image',
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.simplicisticHeader
//     },

//     supremeTestimonial: {
//       // Layout
//       layoutType: 'testimonial-cards',
      
//       // Background Image
//       backgroundImage: '',
//       backgroundImageOpacity: 20, // Prozent-Wert für neue ImageContainer
//       imageEffect: 'none',
      
//       // Main Quote
//       mainQuote: 'Tony Robbins hat mir geholfen, herauszufinden, was wirklich in mir steckt. Mit Tonys Hilfe habe ich mir neue Maßstäbe gesetzt und mein Tennisspiel – und mein Leben – auf ein ganz neues Niveau gebracht!',
      
//       // Text Shadow
//       textShadow: true,
      
//       // Custom Fonts
//       quoteFont: '',
//       nameFont: '',
//       infoFont: '',
//       testimonialFont: '',
      
//       // Text Effects
//       quoteEffect: '',
      
//       // Text Colors & Sizes
//       quoteColor: '#ffffff',
//       quoteSize: 36,
//       quoteSizeMobile: 28,
//       quoteSizeBig: 42,
//       quoteWeight: '400',
      
//       nameColor: '#ffffff',
//       nameSize: 16,
//       nameWeight: '600',
      
//       infoColor: '#666666',
//       infoSize: 12,
//       infoWeight: '400',
      
//       testimonialColor: '#555555',
//       testimonialSize: 14,
//       testimonialWeight: '400',
      
//       // Avatar Settings
//       avatarSize: 80,
//       cardStyle: 'Invisible',
      
//       // Testimonials Array
//       testimonials: [
//         {
//           name: 'Serena Williams',
//           info: 'Die meisten Grand-Slam-Titel im Einzel der Geschichte (männlich oder weiblich), viermaliger Olympiasieger',
//           quote: 'Tony Robbins hat mir geholfen, herauszufinden, was wirklich in mir steckt. Mit Tonys Hilfe habe ich mir neue Maßstäbe gesetzt und mein Tennisspiel – und mein Leben – auf ein ganz neues Niveau gebracht!',
//           avatar: '/img/testi_1.jpg',
//           backgroundImage: '',
//           website: ''
//         },
//         {
//           name: 'Klay Thompson',
//           info: '4-facher NBA-Champion, 5-facher All-Star, ESPY Best Comeback Athlet',
//           quote: 'The strategies I learned have transformed not just my game, but my entire approach to life and success.',
//           avatar: '/img/testi_2.jpg',
//           backgroundImage: '',
//           website: ''
//         },
//         {
//           name: 'Max Menounos',
//           info: 'Schauspielerin und Fernsehmoderatorin, Krebsüberlebende',
//           quote: 'This program gave me the strength and clarity I needed during the most challenging time of my life.',
//           avatar: '/img/testi_3.jpg',
//           backgroundImage: '',
//           website: ''
//         },
//         {
//           name: 'Anne Benioff',
//           info: 'Salesforce-Gründer und CEO, Eigentümer des TIME-Magazins',
//           quote: 'The insights from this program have revolutionized how I lead my company and live my life.',
//           avatar: '/img/testi_5.jpg',
//           backgroundImage: '',
//           website: ''
//         }
//       ],
      
//       // Layout
//       backgroundColor: '#000000',
//       height: 900,
//       borderRadius: 0,
//       marginTop: 0,
//       marginBottom: 0,
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // 🚀 STANDARD LAYOUT PROPERTIES (Revolutionary Layout System)
//       // Spacing - Desktop
//       paddingTop: 60,
//       paddingBottom: 60,
      
//       // Spacing - Mobile
//       paddingTopMobile: 40,
//       paddingBottomMobile: 40,
      
//       // Height Dimensions - Desktop
//       minHeight: 0,
      
//       // Height Dimensions - Mobile
//       heightMobile: 'auto',
//       minHeightMobile: 0,
      
//       // Widget Meta
//       imagePreview: '/img/fancy_testimonial.jpg',
//       id: '',
//       type: 'SupremeTestimonial',
//       name: 'Supreme Testimonial',
//       position: '26',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Basic',
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.supremeTestimonial
//     },

//     simplicisticQuote: {
//       // Content Properties
//       categoryText: 'About Us', // ✅ NEUES TEXT-ELEMENT über dem Titel
//       simpleText: 'This is a simple text that provides context or introduction to your rich text content below.',
//       richText: 'Create beautiful quotes\nwith rich formatting and styling options.',
//       // ✅ HIGHLIGHT-SYSTEM für richText
//       richTextHighlightWords: 'beautiful quotes', // Komma-getrennte Wörter zum Highlighten
//       richTextHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//       richTextHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//       richTextHighlightWeight: '800', // Font-Weight für highlighted Wörter
//       richTextHighlightWeightMobile: '800', // Mobile Font-Weight für highlighted Wörter
//       richTextHighlightWeightBig: '800', // Big Screen Font-Weight für highlighted Wörter
//       richTextHighlightEffect: '', // Text-Effect für highlighted Wörter
//       richTextHighlightSize: 44, // Desktop Font-Größe (gleich wie richTextSize)
//       richTextHighlightSizeMobile: 28, // Mobile Font-Größe (gleich wie richTextSizeMobile)
//       richTextHighlightSizeBig: 52, // Big Screen Font-Größe (gleich wie richTextSizeBig)
//       richTextHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
//       richTextHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
      
//       // Background Image
//       backgroundImage: '',
//       backgroundImageOpacity: 80,
//       backgroundImageBlur: 0,
//       imageEffect: 'none',
      
//       // Content Image
//       optionalImage: '/img/yoga_girl.jpg', // ✅ Test-Bild für Layout-Tests
//       imageWidth: 300,
//       imageSpacing: 20,
//       imageMargin: 20,             // ✅ Abstand zwischen Bild und Text
//       imagePosition: 'top',        // Image position: 'top', 'left', 'right'
      
//       // Text Alignment & Responsive
//       textAlignment: 'center',
//       textAlignmentMobile: 'center',
      
//       // Text Max Width Settings
//       enableTextMaxWidth: false,       // ✅ Toggle für Max Width
//       textMaxWidth: 600,               // ✅ Max Width für Texte (px)
      
//       // Button Configuration
//       buttonText: 'Learn More',
//       buttonLink: '',
      
//       // Button Styling
//       showButtonText: true,            // ✅ Button Toggle
//       buttonColor: '#667eea',          // Button Background Color
//       buttonTextColor: '#ffffff',      // Button Text Color
//       buttonTextSize: 16,              // Desktop Font Size
//       buttonTextSizeMobile: 14,        // Mobile Font Size
//       buttonTextWeight: '600',         // Font Weight
//       buttonTextWeightMobile: '600',   // Mobile Font Weight
//       buttonFontFamilyFamily: '',                  // Button Font (leer = globalSmallFont)
      
//       // Button Dimensions - ERWEITERT für ButtonWidgetStyle-Kompatibilität
//       buttonWidth: 80,                 // Button Width (%) - Legacy
//       buttonWidthMobile: 90,           // Mobile Button Width (%) - Legacy
//       buttonWidthDesktop: 200,         // ✅ NEU: Desktop Width (px) für ButtonWidgetStyle
//       buttonMaxWidth: 300,             // Max Width (px)
//       buttonMaxWidthMobile: 280,       // Mobile Max Width (px)
//       buttonHeight: 50,                // Button Height (px)
//       buttonHeightMobile: 45,          // Mobile Button Height (px)
//       buttonBorderRadius: 8,           // Border Radius (px)
//       buttonBorderRadiusMobile: 6,     // Mobile Border Radius (px)
      
//       // ✅ VOLLSTÄNDIGE BUTTON PROPERTIES für ButtonWidgetStyle 2025
//       buttonBorderEnabled: false,      // Border Toggle
//       buttonBorderWidth: 2,            // Border Width (px)
//       buttonBorderColor: '#5C80BC',    // Border Color
//       buttonAnimation: 'none',         // Animation Type (Legacy)
//       buttonFontFamilyFamily: '',                  // Button Font (leer = globalSmallFont)
      
//       // ✅ GRADIENT SYSTEM
//       buttonGradientEnabled: false,    // Enable Gradient Background
//       buttonGradientColor1: '#667eea', // Gradient Color 1
//       buttonGradientColor2: '#764ba2', // Gradient Color 2
//       buttonGradientAnimation: false,  // Enable Gradient Animation
      
//       // ✅ SHADOW SYSTEM
//       buttonShadowEnabled: false,      // Enable Button Shadow
//       buttonShadowIntensity: 15,       // Shadow Blur (5-50px)
//       buttonShadowDistance: 8,         // Shadow Distance (0-30px)
//       buttonShadowOpacity: 25,         // Shadow Opacity (5-80%)
//       buttonShadowColor: '#000000',    // Shadow Color
      
//       // ✅ ANIMATION SYSTEM (New)
//       buttonAnimationsEnabled: false,  // Enable Button Animations
//       buttonAnimationType: 'gentle-pulse', // Animation Type (gentle-pulse, gentle-sway, etc.)
//       buttonAnimationSpeed: 2000,      // Animation Speed (800-4000ms)
      
//       // Custom Fonts
//       simpleTextFont: '',
//       richTextFont: '',
      
//       // Text Effects
//       categoryTextEffect: '',   // ✅ Effect für Category Text
//       simpleTextEffect: '',
//       richTextEffect: '',
      
//       // Text Colors & Sizes
//       categoryTextColor: '#999999', // ✅ Hellere Farbe für Category
//       categoryTextSize: 12,         // ✅ Kleine Schrift
//       categoryTextSizeMobile: 11,   // ✅ Noch kleiner auf Mobile
//       categoryTextWeight: '500',    // ✅ Medium Weight
      
//       // Category Text Styling (spezielle Optionen)
//       categoryTextBackgroundColor: 'transparent', // ✅ Hintergrundfarbe
//       categoryTextPaddingWidth: 0,   // ✅ Padding Width (px)
//       categoryTextPaddingHeight: 0,  // ✅ Padding Height (px)
//       categoryTextBorderRadius: 0,   // ✅ Border Radius (px)
//       categoryTextBorderWidth: 0,    // ✅ Border Width (px)
//       categoryTextBorderColor: '#cccccc', // ✅ Border Color
      
//       simpleTextColor: '#666666',
//       simpleTextSize: 14,
//       simpleTextSizeMobile: 14,
//       simpleTextWeight: '400',
      
//       richTextColor: '#2c3e50',
//       richTextSize: 44,
//       richTextSizeMobile: 28,
//       richTextWeight: '600',
//       richTextWeightMobile: '600',
//       richTextWeightBig: '600',
      
//       // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//       height: 'auto',         // ✅ AUTO HEIGHT: Passt sich an Content an
//       heightMobile: 'auto',   // ✅ AUTO HEIGHT: Mobile auch auto
//       minHeight: 600,         // ✅ MIN HEIGHT: Mindesthöhe für Desktop
//       minHeightMobile: 800,   // ✅ MIN HEIGHT: Mindesthöhe für Mobile
//       maxWidth: 800,          // ✅ MAX WIDTH: Widget Container Max Width
//       maxWidthMobile: 800,    // ✅ MAX WIDTH: Mobile Widget Container Max Width
//       paddingTop: 50,         // ✅ Mehr Padding für bessere Optik
//       paddingTopMobile: 40,   // Mobile Padding
//       paddingBottom: 50,      // ✅ Mehr Padding für bessere Optik
//       paddingBottomMobile: 40, // Mobile Padding
//       marginTop: 0,
//       marginBottom: 0,
//       borderRadius: 0,
      
//       // Layout System
//       layoutType: 'image-top-centered', // ✅ Default Layout geändert
      
//       // Basic Layout
//       backgroundColor: '#ffffff',
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // Visibility Toggles
//       showCategoryText: true,   // ✅ Toggle für Category Text
//       showSimpleText: true,
//       showRichText: true,
//       showContentImage: true,
//       showBackgroundImage: false,
      
//       // Animation Settings
//       enableAnimations: false,
//       animationType: 'fadeInUp',
//       animationDuration: 600,
//       animationDelay: 200,
//       triggerAnimation: 0,
      
//       // Widget Meta (REQUIRED)
//       imagePreview: '/img/simplistic_quote.jpg',
//       id: '',
//       type: 'SimplisticQuote',
//       name: 'Simplistic Quote',
//       position: '27',
//       isSelected: false,
//       cat1: 'Basic',
//       cat2: 'Text',
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.simplicisticQuote
//     },

//     methodologyWidget: {
//       // Profile Image
//       profileImage: '/img/yoga_girl.jpg',
//       profileImageWidth: 400,
//       profileImageHeight: 500,
      
//       // Underlay System
//       showUnderlay: false,
//       underlayImage: '/img/abstract.svg',
//       underlaySize: 200,
//       underlayOpacity: 0.3,
//       underlayRotation: 0, // 0-360 degrees
//       underlayPosition: 'bottom-left', // bottom-left, bottom-right, top-left, top-right
//       underlayInvert: false, // Color invert filter
      
//       // Main Content
//       mainTitle: 'MY METHODOLOGY',
//       mainDescription: 'My clients get gorgeous, divine, out-of-this-world results for a reason.',
//       mainContent: '<p>What I teach is the alchemy of feminine leadership that gets you results in <strong>business, love, and life.</strong></p><p>A synthesis of transformational coaching that weaves together ancient wisdom with modern neuroscience.</p><p><em>It initiates her into her truest, biggest, boldest self.</em></p>',
      
//       // Steps Content
//       step1Number: '01',
//       step1Title: 'Body Based Transformational Coaching and Somatics',
//       step1Description: 'I don\'t coach you through your mind. I coach you through your body so that you transform on a somatic, nervous system level—and that\'s exactly why my clients experience wild results that last.',
      
//       step2Number: '02',
//       step2Title: 'Feminine Leadership Mentorship',
//       step2Description: 'I mentor you to expand your business and create wealth from the root of your deep feminine power and lead with your heart, spine, and womb.',
      
//       step3Number: '03',
//       step3Title: 'Deep Feminine Energetics and Archetype Work',
//       step3Description: 'I teach you how to live, love, and lead in your full-range deep feminine energy, expression, and embodiment, where your power, aura, and standards speak for you.',
      
//       // Custom Fonts
//       mainTitleFont: '',
//       mainDescriptionFont: '',
//       additionalTextFont: '',
//       stepNumberFont: '',
//       stepTitleFont: '',
//       stepDescriptionFont: '',
      
//       // Text Effects
//       mainTitleEffect: '',
//       mainDescriptionEffect: '',
//       stepNumberEffect: '',
//       stepTitleEffect: '',
      
//       // Text Colors & Sizes
//       mainTitleColor: '', // Will be set by AI Design System
//       mainTitleSize: 48,
//       mainTitleSizeMobile: 36,
//       mainTitleSizeBig: 56,
//       mainTitleWeight: '400',
//       mainTitleStyle: 'italic',
      
//       mainDescriptionColor: '', // Will be set by AI Design System
//       mainDescriptionSize: 18,
//       mainDescriptionSizeMobile: 16,
//       mainDescriptionSizeBig: 20,
//       mainDescriptionWeight: '400',
//       mainDescriptionStyle: 'italic',
      
//       additionalTextColor: '', // Will be set by AI Design System
//       additionalTextSize: 16,
//       additionalTextSizeMobile: 14,
//       additionalTextSizeBig: 18,
//       additionalTextWeight: '300',
      
//       conclusionTextColor: '', // Will be set by AI Design System
//       conclusionTextSize: 16,
//       conclusionTextSizeMobile: 14,
//       conclusionTextSizeBig: 18,
//       conclusionTextWeight: '400',
//       conclusionTextStyle: 'italic',
      
//       stepNumberColor: '', // Will be set by AI Design System
//       stepNumberSize: 72,
//       stepNumberSizeMobile: 56,
//       stepNumberSizeBig: 84,
//       stepNumberWeight: '300',
//       stepNumberStyle: 'italic',
      
//       stepTitleColor: '', // Will be set by AI Design System
//       stepTitleSize: 24,
//       stepTitleSizeMobile: 20,
//       stepTitleSizeBig: 28,
//       stepTitleWeight: '400',
//       stepTitleStyle: 'italic',
      
//       stepDescriptionColor: '', // Will be set by AI Design System
//       stepDescriptionSize: 14,
//       stepDescriptionSizeMobile: 12,
//       stepDescriptionSizeBig: 16,
//       stepDescriptionWeight: '300',
      
//       // Layout System
//       layoutType: 'classic-methodology', // Default layout
//       backgroundColor: '#000000',
//       contentSpacing: 60,
//       stepSpacing: 40,
//       height: 'auto',
//       borderRadius: 0,
//       marginTop: 0,
//       marginBottom: 0,
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // Widget Meta
//       imagePreview: '/img/methodology.jpg',
//       id: '',
//       type: 'MethodologyWidget',
//       name: 'Methodology Widget',
//       position: '28',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Image',
      
//       // Animation Settings (2025 Animation System)
//       enableAnimations: false,
//       animationType: 'fadeInUp',
//       animationDuration: 600,
//       animationDelay: 200,
//       triggerAnimation: null,
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.methodologyWidget
//     },

//     personalBrandingWidget: {
//       // Profile Image
//       profileImage: '/img/freedom_girl.jpg',
//       profileImageHeight: 600,
//       imageDescription: 'Emma Mumford is the UK\'s leading Manifestation expert, helping hundreds of thousands of people turn their dream life into an abundant reality. She is a four-time bestselling author, award-winning life coach, renowned speaker, and trusted Law of Attraction YouTuber. Emma is also the host of Aligned Abundance, the #1 spirituality podcast on iTunes.',
      
//       // Overlay Text (appears over the image)
//       overlayName: 'Hi, I\'m Emma',
//       overlayTitle1: 'Manifestation Expert.',
//       overlayTitle2: 'Bestselling author. Podcaster.',
//       overlayTitle3: 'Spiritual Queen.',
      
//       // Main Content
//       mainQuestion: 'Do you feel like your dream life is always just out of reach?',
//       helpText: 'I can help you:',
      
//       // Dynamic Bullet Points (can add/remove)
//       bulletPoints: [
//         {
//           id: 'bp1',
//           text: 'Get out of the rut you\'ve found yourself in so you can start living the life of your dreams'
//         },
//         {
//           id: 'bp2', 
//           text: 'Break past your limiting beliefs and blocks so you can step into your full potential and feel genuinely fulfilled'
//         },
//         {
//           id: 'bp3',
//           text: 'Manifest the abundant life you\'ve been craving so you can finally stop dreaming, and start living.'
//         }
//       ],
      
//       // Bullet Point Style
//       bulletPointStyle: 'elegant', // elegant, modern, luxury, minimal, default
      
//       // Call to Action Button
//       buttonText: 'LEARN MORE ABOUT MY WORK',
//       buttonLink: '',
      
//       // Custom Fonts
//       overlayNameFont: '',
//       overlayTitleFont: '',
//       mainQuestionFont: '',
//       helpTextFont: '',
//       bulletPointFont: '',
//       buttonFontFamilyFamily: '',
//       imageDescriptionFont: '',
      
//       // Text Effects
//       overlayNameEffect: '',
//       overlayTitleEffect: '',
//       mainQuestionEffect: '',
//       bulletPointEffect: '',
//       buttonEffect: '',
      
//       // Text Colors & Sizes
//       overlayNameColor: '#8B7355',
//       overlayNameSize: 36,
//       overlayNameSizeMobile: 28,
//       overlayNameSizeBig: 42,
//       overlayNameWeight: '400',
//       overlayNameStyle: 'italic',
      
//       overlayTitleColor: '#6B6B6B',
//       overlayTitleSize: 20,
//       overlayTitleSizeMobile: 18,
//       overlayTitleSizeBig: 24,
//       overlayTitleWeight: '400',
//       overlayTitleStyle: 'italic',
      
//       mainQuestionColor: '#4A4A4A',
//       mainQuestionSize: 32,
//       mainQuestionSizeMobile: 24,
//       mainQuestionSizeBig: 36,
//       mainQuestionWeight: '400',
      
//       helpTextColor: '#666666',
//       helpTextSize: 16,
//       helpTextSizeMobile: 14,
//       helpTextSizeBig: 18,
//       helpTextWeight: '400',
      
//       bulletPointColor: '#5A5A5A',
//       bulletPointSize: 14,
//       bulletPointSizeMobile: 12,
//       bulletPointSizeBig: 16,
//       bulletPointWeight: '400',
      
//       imageDescriptionColor: '#666666',
//       imageDescriptionSize: 12,
//       imageDescriptionSizeMobile: 10,
//       imageDescriptionSizeBig: 14,
//       imageDescriptionWeight: '400',
      
//       // 🚀 RESPONSIVE BUTTON STYLING - Desktop/Mobile
//       // Typography
//       buttonTextSize: 14,                    // Desktop Font Size
//       buttonTextSizeMobile: 12,              // Mobile Font Size
//       buttonTextWeight: '600',               // Desktop Font Weight
//       buttonTextWeightMobile: '600',         // Mobile Font Weight
      
//       // Dimensions
//       buttonWidth: 100,                      // Desktop Width %
//       buttonWidthMobile: 100,                // Mobile Width %
//       buttonMaxWidth: 600,                   // Desktop Max Width px
//       buttonMaxWidthMobile: 280,             // Mobile Max Width px
//       buttonHeight: 50,                      // Desktop Height px
//       buttonHeightMobile: 48,                // Mobile Height px
//       buttonBorderRadius: 4,                 // Desktop Border Radius px
//       buttonBorderRadiusMobile: 4,           // Mobile Border Radius px
      
//       // Colors & Styling
//       buttonColor: '#8B7355',                // Button Background Color
//       buttonTextColor: '#FFFFFF',            // Button Text Color
      
//       // Gradient System
//       buttonGradientEnabled: false,          // Enable Gradient Background
//       buttonGradientColor1: '#8B7355',       // Gradient Color 1
//       buttonGradientColor2: '#A68B6A',       // Gradient Color 2
//       buttonGradientAnimation: false,        // Enable Gradient Animation
      
//       // Shadow System
//       buttonShadowEnabled: false,            // Enable Button Shadow
//       buttonShadowIntensity: 15,             // Shadow Blur (5-50px)
//       buttonShadowDistance: 8,               // Shadow Distance (0-30px)
//       buttonShadowOpacity: 25,               // Shadow Opacity (5-80%)
//       buttonShadowColor: '#000000',          // Shadow Color
      
//       // Border System
//       buttonBorderEnabled: false,            // Enable Button Border
//       buttonBorderWidth: 2,                  // Border Width (1-8px)
//       buttonBorderColor: '#8B7355',          // Border Color
      
//       // Button Animations System
//       buttonAnimationsEnabled: false,        // Enable Button Animations
//       buttonAnimationType: 'gentle-pulse',   // Animation Type
//       buttonAnimationSpeed: 2000,            // Animation Speed (800-4000ms)
      
//       // Legacy Button Fields (for backwards compatibility)
//       buttonPaddingY: 16,                    // DEPRECATED - use buttonHeight
//       buttonPaddingX: 32,                    // DEPRECATED - use buttonWidth/buttonMaxWidth
//       buttonMinWidth: 600,                   // DEPRECATED - use buttonMaxWidth
      
//       // Layout
//       backgroundColor: '#F5F5F0',
//       contentSpacing: 40,
//       bulletSpacing: 16,
//       overlayOpacity: 0.9,
//       containerPadding: 35,
//       height: 'auto',
//       borderRadius: 0,
//       marginTop: 0,
//       marginBottom: 0,
//       border: false,
//       borderColor: '#CCCCCC',
      
//       // Container Layout Options
//       containerLayout: 'glass-card', // 'glass-card', 'floating-island', 'magazine-cutout', 'neon-glow', 'origami-fold', 'vintage-card', 'minimal-border', 'accordion'
//       bulletPointStyle: 'elegant', // 'elegant', 'modern', 'luxury', 'minimal'
//       bulletPointDesign: 'default', // 'default', 'cards', 'bordered', 'highlighted', 'rounded', 'gradient', 'vintage'
      
//       // Widget Meta
//       imagePreview: '/img/personal_branding.jpg',
//       id: '',
//       type: 'PersonalBrandingWidget',
//       name: 'Personal Branding',
//       position: '29',
//       isSelected: false,
//       cat1: 'Fancy',
//       cat2: 'Image',
      
//       // Animation Settings (2025 Animation System)
//       enableAnimations: false,
//       animationType: 'fadeInUp',
//       animationDuration: 600,
//       animationDelay: 150,
//       triggerAnimation: null,
      
//       // AI Integration
//       aiInfo: aiWidgetInfos.personalBrandingWidget
//     },


//     simplisticTestimonial: {
//         // Main Content
//         titleText: 'What Our Customers Say',
//         subtitleText: 'Discover what our amazing customers have to say about their experience with our service.',
        
//         // ✅ HIGHLIGHT-SYSTEM für titleText
//         titleHighlightWords: '', // Komma-getrennte Wörter zum Highlighten
//         titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//         titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//         titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
//         titleHighlightEffect: '', // Text-Effect für highlighted Wörter
//         titleHighlightSize: 32, // Desktop Font-Größe (gleich wie titleSize)
//         titleHighlightSizeMobile: 28, // Mobile Font-Größe (gleich wie titleSizeMobile)
//         titleHighlightSizeBig: 36, // Big Screen Font-Größe (gleich wie titleSizeBig)
//         titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
//         titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
        
//         // Custom Fonts (optional - falls leer wird globalFont verwendet)
//         titleFont: '',
//         subtitleFont: '',
//         testimonialTextFont: '',
//         testimonialAuthorFont: '',
//         testimonialTitleFont: '',
        
//         // Text Effects (optional - falls leer wird kein Effekt angewendet)
//         titleEffect: '',
//         subtitleEffect: '',
        
//         // Main Text Colors & Sizes
//         titleColor: '#000000',
//         titleSize: 32,
//         titleSizeMobile: 28,
//         titleSizeBig: 36,
//         titleWeight: '600',
        
//         subtitleColor: '#666666',
//         subtitleSize: 18,
//         subtitleSizeMobile: 16,
//         subtitleSizeBig: 20,
//         subtitleWeight: '400',
        
//         // Testimonials Array - dynamisch erweiterbar
//         testimonials: [
//             {
//                 text: 'This service completely transformed my business. The results exceeded all my expectations and the support team was amazing throughout the entire process.',
//                 author: 'Sarah Johnson',
//                 title: 'CEO, Tech Startup',
//                 image: '/img/testi_1.jpg',
//                 website: ''
//             },
//             {
//                 text: 'Amazing results and outstanding support. I would highly recommend this to anyone looking to grow their business.',
//                 author: 'Michael Smith',
//                 title: 'Marketing Director',
//                 image: '/img/testi_2.jpg',
//                 website: ''
//             },
//             {
//                 text: 'Professional, efficient, and results-driven. This investment has paid for itself many times over.',
//                 author: 'Emma Davis',
//                 title: 'Freelance Designer',
//                 image: '/img/testi_3.jpg',
//                 website: ''
//             }
//         ],
        
//         // Testimonial Styling
//         testimonialBackgroundColor: '#ffffff',
//         testimonialTextColor: '#333333',
//         testimonialTextSize: 16,
//         testimonialTextWeight: '400',
//         testimonialItalic: false,
//         testimonialQuotes: true,
        
//         testimonialAuthorColor: '#000000',
//         testimonialAuthorSize: 16,
//         testimonialAuthorWeight: '600',
        
//         testimonialTitleColor: '#666666',
//         testimonialTitleSize: 14,
//         testimonialTitleWeight: '400',
        
//         // Testimonial Card Settings
//         testimonialBorder: false,
//         testimonialBorderColor: '#e0e0e0',
//         testimonialBorderRadius: 12,
//         testimonialPadding: 24,
//         // ✅ NEW: Erweiterte Padding-Optionen (Horizontal/Vertical)
//         testimonialPaddingHorizontal: 24,
//         testimonialPaddingVertical: 24,
//         testimonialShadow: true,
//         testimonialSpacing: 30,
        
//         // ✅ NEW: Card Height Controls (Responsive)
//         testimonialCardHeight: 300, // Desktop Card Height
//         testimonialCardHeightMobile: 250, // Mobile Card Height
        
//         // ✅ NEW: Card Max Width Control (Responsive)
//         testimonialCardMaxWidth: 450, // Desktop Card Max Width
//         testimonialCardMaxWidthMobile: 350, // Mobile Card Max Width
        
//         // ✅ NEW: Text Max Width Control
//         testimonialTextMaxWidth: 600, // Max Width für Testimonial Text
        
//         // Testimonial Images
//         testimonialImageSize: 80,
//         testimonialImageBorder: true, // ✅ Show Image Border Toggle
//         testimonialImageBorderColor: '#e0e0e0',
//         testimonialImageBorderWidth: 2, // ✅ Image Border Width
        
//         // ✅ GLASSMORPHISM SYSTEM - Missing Properties Added
//         testimonialGlassmorphism: false, // Enable glassmorphism effect
//         testimonialGlassStrength: 10, // Backdrop blur strength (5-25px)
        
//         // ✅ NEW: Image Mode System für Full-Width Layouts
//         testimonialImageMode: false, // false = round, true = full-height
//         fullHeightImageWidth: 120, // Width für Full-Height Image (px)
//         fullHeightImageHeight: 250, // Height für Full-Height Image (px)
//         fullHeightImagePosition: 'left', // 'left' | 'right'
        
//         // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//         height: 'auto',            // Desktop Height
//         heightMobile: 'auto',     // Mobile Height (Standard: 1200px)
//         paddingTop: 60,         // Desktop Padding
//         paddingTopMobile: 40,   // Mobile Padding
//         paddingBottom: 60,      // Desktop Padding
//         paddingBottomMobile: 40, // Mobile Padding
//         marginTop: 0,
//         marginBottom: 40,
//         borderRadius: 0,
        
//         // Layout System
//         layoutType: 'classic-grid', // Default Layout (wird durch testimonialLayout überschrieben)
        
//         // Text Alignment & Responsive
//         textAlignment: 'center',
//         textAlignmentMobile: 'center',
        
//         // Visibility Toggles
//         showTitleText: true,
//         showSubtitleText: true,
        
//         // Layout
//         backgroundColor: '#ffffff',
//         contentSpacing: 30,
//         maxWidth: 1000, // Maximum width of widget content
//         subtitleMaxWidth: 700, // Maximum width of subtitle text
//         border: false,
//         borderColor: '#CCCCCC',
        
//         // ✅ BACKGROUND IMAGE SYSTEM - Missing Properties Added
//         showBackgroundImage: false, // Show background image toggle
//         backgroundImage: '', // Background image URL
//         backgroundImageOpacity: 50, // Background image opacity (10-100%)
//         backgroundImageSize: 'cover', // cover|contain|auto
//         backgroundImagePosition: 'center', // center|top|bottom|left|right|etc.
//         backgroundImageBlur: 0, // Blur intensity (0-10px)
        
//         // Testimonial Layout Options
//         testimonialLayout: 'classic-grid', // 'classic-grid', 'masonry-flow', 'luxury-cards', 'glass-panels', 'paper-cards'
        
//         // Widget Meta
//         imagePreview: '/img/simplistic_testimonial.jpg',
//         id: '',
//         type: 'SimplisticTestimonial',
//         name: 'Simplistic Testimonial',
//         position: '1',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Image',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.simplisticTestimonial
//     },

//     // Event Widgets (Events & Live Events)
//     eventInfoWidget: {
//         // Event Connection
//         eventId: '', // Wird dynamisch gesetzt
        
//         // Display Settings - Core Info
//         showTitle: true,
//         showDescription: true,
//         showEventType: true, // Digital Event / In-Person Event
//         showLocation: true, // Meeting URL or Address
//         showEventDays: true,
//         showTimeSlots: true,
//         showTickets: true,
//         showButton: true,
        
//         // Custom Features (Event-specific)
//         showCustomFeatures: true,
//         customFeatures: [
//             { text: 'Expert speakers included' },
//             { text: 'Networking opportunities' },
//             { text: 'Certificate of completion' },
//             { text: 'Live Q&A sessions' },
//             { text: 'Event recordings included' }
//         ],
//         featuresIconColor: '#f59e0b', // Event orange color
//         featuresLayout: 'grid', // grid|column
        
//         // Background Image
//         backgroundImage: '/img/event-background.jpg',
//         backgroundImageOpacity: 85, // Prozent-Wert für neue ImageContainer
//         imageEffect: 'blur', // none|blur|grayscale|top-fade|etc.
        
//         // Event Image
//         eventImage: '/img/event-hero.jpg',
//         showEventImage: true,
//         eventImageMode: 'banner', // normal|banner
//         eventImagePosition: 'right', // right|left|top|bottom|center
//         eventImageShape: 'rectangle', // rectangle|rounded|circle
//         eventImageAlignment: 'center',
        
//         // Normal Mode Settings
//         eventImageWidth: 300,
//         eventImageHeight: 200,
//         eventImageBorderRadius: 12,
        
//         // Banner Mode Settings
//         bannerImageWidth: 40,
//         bannerImageAlignment: 'right',
        
//         // Layout Settings
//         layout: 'card', // hero|card|inline|minimal|timeline
//         contentAlignment: 'left', // left|center|right
//         backgroundColor: '#ffffff',
//         borderRadius: 16,
//         padding: 40,
//         marginTop: 0,
//         marginBottom: 0,
//         height: 600,
        
//         // Border Settings
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // Text Styling
//         titleColor: '#1e293b',
//         titleSize: 32,
//         titleSizeMobile: 24,
//         titleSizeBig: 40,
//         titleWeight: '700',
//         titleWeightMobile: '700',
//         titleWeightBig: '700',
//         titleFont: '',
//         titleEffect: '',
        
//         descriptionColor: '#64748b',
//         descriptionSize: 16,
//         descriptionSizeMobile: 18,
//         descriptionSizeBig: 20,
//         descriptionWeight: '400',
//         descriptionWeightMobile: '400',
//         descriptionWeightBig: '400',
//         descriptionFont: '',
//         descriptionEffect: '',
        
//         // Event Type Styling
//         eventTypeColor: '#f59e0b',
//         eventTypeSize: 14,
//         eventTypeWeight: '600',
//         eventTypeFont: '',
//         eventTypeBadgeStyle: 'pill', // pill|square|minimal
        
//         // Location/Date Styling
//         locationColor: '#64748b',
//         locationSize: 14,
//         locationWeight: '500',
//         locationFont: '',
        
//         dateColor: '#6366f1',
//         dateSize: 16,
//         dateWeight: '600',
//         dateFont: '',
        
//         // Ticket Styling
//         ticketCardStyle: 'modern', // modern|classic|minimal
//         ticketPriceColor: '#059669',
//         ticketPriceSize: 24,
//         ticketPriceWeight: '700',
//         ticketPriceFont: '',
        
//         // Button Configuration
//         buttonText: 'Reserve Your Spot',
//         buttonLink: '',
//         buttonColor: '#f59e0b',
//         buttonTextColor: '#ffffff',
//         buttonBorderRadius: 8,
//         buttonPaddingY: 16,
//         buttonPaddingX: 32,
//         buttonFontFamilyFamily: '',
//         buttonEffect: '', // Leer = kein Effekt
        
//         // Customizable Section Titles (Multi-Language Support)
//         scheduleTitle: 'Event Schedule',
//         featuresTitle: 'What\'s Included',
//         ticketsTitle: 'Tickets',
//         availabilityTitle: 'Availability',
//         includesTitle: 'INCLUDES',
        
//         // 🚀 TEXT REFACTORING 2025 - Show/Hide Toggles für Text-Felder
//         showScheduleTitle: true,
//         showFeaturesTitle: true,
//         showTicketsTitle: true,
//         showAvailabilityTitle: true,
//         showIncludesTitle: true,
//         showFreeTicketButtonText: true,
//         showBuyTicketButtonText: true,
//         showAvailableText: true,
//         showHalfSoldText: true,
//         showSellingFastText: true,
//         showAlmostSoldOutText: true,
//         showLimitedText: true,
        
//         // Customizable Button Texts
//         freeTicketButtonText: 'Get Free Ticket',
//         buyTicketButtonText: 'Buy Ticket',
        
//         // Payment Integration
//         useStripeCheckout: true,
//         stripeTextColor: '#64748b',
//         showStripePayment: true,
//         paymentMethod: 'stripe', // Default payment method
        
//         // Customizable Status Messages
//         availableText: 'Available',
//         halfSoldText: 'Half Sold',
//         sellingFastText: 'Selling Fast!',
//         almostSoldOutText: 'Almost Sold Out!',
//         limitedText: 'Limited',
        
//         // Timeline Layout (for timeline layout)
//         timelineStyle: 'vertical', // vertical|horizontal
//         showTimelineConnectors: true,
//         timelineAccentColor: '#f59e0b',
        
//         // Advanced Display Options
//         maxEventDaysToShow: 3, // Limit displayed days
//         maxTicketsToShow: 4, // Limit displayed tickets
//         showSoldOutTickets: true,
//         compactMode: false, // Compact display for smaller spaces
        
//         // Ticket Style System - Individual styles per ticket
//         ticketStyles: {
//             // Format: ticketIndex: 'styleType'
//             // 0: 'golden',
//             // 1: 'silver', 
//             // 2: 'premium',
//             // 3: 'standard'
//         },
        
//         // Ticket Availability System (Dynamic from Event Data)
//         showTicketAvailability: true,
        
//         // Responsive Settings
//         mobileLayout: 'stack', // stack|scroll|accordion
//         showExpandButton: true, // For mobile compact view
        
//         // Animation & Effects
//         hoverEffect: 'lift', // none|lift|glow|scale
//         entranceAnimation: 'fadeIn', // none|fadeIn|slideUp|slideIn
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/simplistic_testimonial.jpg',
//         id: '',
//         type: 'EventInfoWidget',
//         name: 'Event Information',
//         position: '13',
//         isSelected: false,
//         cat1: 'Product',
//         cat2: 'Info',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.eventInfoWidget
//     },

//     // Course Widgets (Video Courses & Online Learning)
//     courseInfoWidget: {
//         // Course Connection
//         courseId: '', // Wird dynamisch gesetzt
        
//         // Display Settings - Core Info
//         showTitle: true,
//         showDescription: true,
//         showCourseType: true, // Online Course, Masterclass, etc.
//         showDuration: true, // Total course duration
//         showModules: true,
//         showModuleDetails: true, // Description, duration per module
//         showFeaturePoints: true, // Learning outcomes & features per module
//         showDocuments: true, // Course materials
//         moduleStyle: 'apple', // Module design style
//         showButton: true,
        
//         // Custom Features (Course-specific)
//         showCustomFeatures: true,
//         customFeatures: [
//             { text: 'Lifetime access included' },
//             { text: 'Certificate of completion' },
//             { text: 'Downloadable resources' },
//             { text: 'Community access' },
//             { text: 'Mobile learning app' }
//         ],
//         featuresIconColor: '#10b981', // Course green color
//         featuresLayout: 'grid', // grid|column
        
//         // Background Image
//         backgroundImage: '/img/course-background.jpg',
//         backgroundImageOpacity: 85, // Prozent-Wert für neue ImageContainer
//         imageEffect: 'blur', // none|blur|grayscale|top-fade|etc.
        
//         // Course Image
//         courseImage: '/img/course-hero.jpg',
//         showCourseImage: true,
//         courseImageMode: 'banner', // normal|banner
//         courseImagePosition: 'right', // right|left|top|bottom|center
//         courseImageShape: 'rectangle', // rectangle|rounded|circle
//         courseImageAlignment: 'center',
        
//         // Normal Mode Settings
//         courseImageWidth: 300,
//         courseImageHeight: 200,
//         courseImageBorderRadius: 12,
        
//         // Banner Mode Settings
//         bannerImageWidth: 40,
//         bannerImageAlignment: 'right',
        
//         // Layout Settings
//         layout: 'card', // hero|card|inline|minimal|timeline
//         contentAlignment: 'left', // left|center|right
//         backgroundColor: '#ffffff',
//         borderRadius: 16,
//         padding: 40,
//         marginTop: 0,
//         marginBottom: 0,
//         height: 600,
        
//         // Border Settings
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // Text Styling
//         titleColor: '#1e293b',
//         titleSize: 32,
//         titleSizeMobile: 24,
//         titleSizeBig: 40,
//         titleWeight: '700',
//         titleWeightMobile: '700',
//         titleWeightBig: '700',
//         titleFont: '',
//         titleEffect: '',
        
//         descriptionColor: '#64748b',
//         descriptionSize: 16,
//         descriptionSizeMobile: 18,
//         descriptionSizeBig: 20,
//         descriptionWeight: '400',
//         descriptionWeightMobile: '400',
//         descriptionWeightBig: '400',
//         descriptionFont: '',
//         descriptionEffect: '',
        
//         // Course Type Styling
//         courseTypeColor: '#10b981',
//         courseTypeSize: 14,
//         courseTypeWeight: '600',
//         courseTypeFont: '',
//         courseTypeBadgeStyle: 'pill', // pill|square|minimal
        
//         // Module Styling
//         moduleColor: '#64748b',
//         moduleSize: 14,
//         moduleWeight: '500',
//         moduleFont: '',
        
//         durationColor: '#6366f1',
//         durationSize: 16,
//         durationWeight: '600',
//         durationFont: '',
        
//         // Module Card Styling
//         moduleCardStyle: 'modern', // modern|classic|minimal
        
//         // Button Configuration
//         buttonText: 'Start Learning',
//         buttonLink: '',
//         buttonColor: '#10b981',
//         buttonTextColor: '#ffffff',
//         buttonBorderRadius: 8,
//         buttonPaddingY: 16,
//         buttonPaddingX: 32,
//         buttonFontFamilyFamily: '',
//         buttonEffect: '', // Leer = kein Effekt
        
//         // Advanced Display Options
//         maxModulesToShow: 6, // Limit displayed modules
//         compactMode: false, // Compact display for smaller spaces
        
//         // Responsive Settings
//         mobileLayout: 'stack', // stack|scroll|accordion
//         showExpandButton: true, // For mobile compact view
        
//         // Animation & Effects
//         hoverEffect: 'lift', // none|lift|glow|scale
//         entranceAnimation: 'fadeIn', // none|fadeIn|slideUp|slideIn
        
//         // Customizable Section Titles (Multi-Language Support)
//         modulesTitle: 'Course Modules',
//         featuresTitle: 'What\'s Included',
//         durationTitle: 'Duration',
//         materialsTitle: 'Course Materials',
        
//         // 🚀 TEXT REFACTORING 2025 - Show/Hide Toggles für Text-Felder
//         showModulesTitle: true,
//         showFeaturesTitle: true,
//         showDurationTitle: true,
//         showMaterialsTitle: true,
//         showFreeCourseButtonText: true,
//         showBuyCourseButtonText: true,
        
//         // Customizable Button Texts
//         freeCourseButtonText: 'Start Free Course',
//         buyCourseButtonText: 'Enroll Now',
        
//         // Payment Integration
//         useStripeCheckout: true,
//         stripeTextColor: '#64748b',
//         showStripePayment: true,
//         paymentMethod: 'stripe', // Default payment method
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/preview-course-info.webp',
//         id: '',
//         type: 'CourseInfoWidget',
//         name: 'Course Information',
//         position: '14',
//         isSelected: false,
//         cat1: 'Product',
//         cat2: 'Info',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.courseInfoWidget
//     },

//     InfiniteBanner: {
//         // Core Widget Properties
//         backgroundColor: '#ffffff',
//         borderRadius: 12,
//         marginTop: 20,
//         marginBottom: 20,
//         paddingX: 20,
//         paddingY: 20,
//         borderWidth: 0,
//         borderColor: '#e2e8f0',
        
//         // 🚀 STANDARD LAYOUT PROPERTIES (Revolutionary Layout System)
//         // Spacing - Desktop
//         paddingTop: 20,
//         paddingBottom: 20,
        
//         // Spacing - Mobile
//         paddingTopMobile: 15,
//         paddingBottomMobile: 15,
        
//         // Height Dimensions - Desktop (InfiniteBanner verwendet bannerHeight statt height)
//         minHeight: 0,
        
//         // Height Dimensions - Mobile
//         heightMobile: 'auto',
//         minHeightMobile: 0,
        
//         // Banner Configuration
//         bannerBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         bannerHeight: 60,
//         bannerBorderRadius: 8,
        
//         // Animation Settings
//         animationSpeed: 8, // ← Viel schneller: 8 Sekunden statt 30
//         itemSpacing: 40, // pixels between items
//         separatorSymbol: 'dot', // ← Default Symbol-Trenner
        
//         // Typography
//         fontFamily: 'Arial',
//         fontSize: 16,
//         fontWeight: '600',
//         textColor: '#ffffff',
//         textEffect: 'none',
//         textShadow: true,
        
//         // Icon Settings
//         iconColor: '#ffffff',
//         iconSize: 16,
        
//         // Item Styling
//         itemBackground: 'rgba(255, 255, 255, 0.1)',
//         itemBorderRadius: 20,
//         itemBorder: true,
//         itemBorderColor: 'rgba(255, 255, 255, 0.2)',
        
//         // Feature Points
//         featurePoints: [
//             { text: 'Premium Quality', icon: 'fas fa-star' },
//             { text: 'Fast Delivery', icon: 'fas fa-rocket' },
//             { text: '24/7 Support', icon: 'fas fa-headset' },
//             { text: 'Money Back Guarantee', icon: 'fas fa-shield-alt' },
//             { text: 'Free Shipping', icon: 'fas fa-truck' },
//             { text: 'Satisfaction Guaranteed', icon: 'fas fa-thumbs-up' }
//         ],
        
//         // Show/Hide Controls
//         showFeaturePoints: true, // Default: Banner ist sichtbar
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/infinite_banner.jpg',
//         id: '',
//         type: 'InfiniteBanner',
//         name: 'Infinite Banner',
//         position: '15',
//         isSelected: false,
//         cat1: 'Marketing',
//         cat2: 'Banner',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.infiniteBanner
//     },

//     qaWidget: {
//         // Main Content
//         titleText: 'Your Answers To Popular Questions',
        
//         // Layout Configuration (NEW - 6 Layout Options)
//         qaLayout: 'classic-side-image', // classic-side-image|image-top-centered|full-width-minimal|magazine-style|accordion-cards|compact-list
        
//         // Mobile Optimization Settings (NEW)
//         mobileImageHeight: 200, // Mobile image height in px
//         mobileImagePosition: 'top', // top|hidden - Image position on mobile
        
//         // Left Image (30% width)
//         leftImage: '/img/girlboss.jpg',
//         showLeftImage: true,
//         leftImageWidth: 30, // Percentage
//         leftImageHeight: 500,
//         leftImageBorderRadius: 12,
//         leftImageFit: 'cover', // cover|contain|fill
        
//         // Q&A Items - Dynamic Array
//         qaItems: [
//             {
//                 id: 'qa1',
//                 question: 'How many times can I reuse them? How long do they last?',
//                 answer: 'Our patches can be reused up to 5 times and each application lasts for 8-12 hours of effective pain relief.',
//                 isExpanded: false
//             },
//             {
//                 id: 'qa2',
//                 question: 'How do I clean them?',
//                 answer: 'Simply rinse with warm water and mild soap, then let air dry completely before storing.',
//                 isExpanded: false
//             },
//             {
//                 id: 'qa3',
//                 question: 'After it\'s removed how long do the pain-free effects last?',
//                 answer: 'The pain-free effects typically continue for 2-4 hours after removal, depending on individual sensitivity.',
//                 isExpanded: false
//             },
//             {
//                 id: 'qa4',
//                 question: 'How do I know if the patch is working?',
//                 answer: 'You should feel relief within 15-30 minutes of application. The patch will feel warm and you\'ll notice reduced pain.',
//                 isExpanded: false
//             },
//             {
//                 id: 'qa5',
//                 question: 'How long can I keep the patch on?',
//                 answer: 'For optimal results, keep the patch on for 8-12 hours. Do not exceed 12 hours of continuous use.',
//                 isExpanded: false
//             }
//         ],
        
//         // Q&A Styling - RESPONSIVE FONTS (HeroHeader-Style)
//         questionColor: '#2c3e50',
//         questionSize: 16,
//         questionSizeMobile: 15,
//         questionSizeBig: 18,
//         questionWeight: '600',
//         questionWeightMobile: '600',
//         questionWeightBig: '600',
//         questionFont: '', // Uses globalSmallFont
//         questionLineHeight: 1.4,
        
//         answerColor: '#666666',
//         answerSize: 15,
//         answerSizeMobile: 14,
//         answerSizeBig: 16,
//         answerWeight: '400',
//         answerWeightMobile: '400',
//         answerWeightBig: '400',
//         answerFont: '', // Uses globalSmallFont
//         answerLineHeight: 1.6,
        
//         // Q&A Item Styling
//         qaItemBackgroundColor: 'transparent',
//         qaItemBorderStyle: 'frameless', // ✅ Frameless (Connected List) als Default
//         qaItemBorderColor: '#e0e0e0',
//         qaItemBorderWidth: 1,
//         qaItemPaddingVertical: 20, // ✅ Separate Vertical Padding
//         qaItemPaddingHorizontal: 20, // ✅ Separate Horizontal Padding
//         qaItemSpacing: 0, // ✅ Kein Abstand zwischen Items
//         qaItemBorderRadius: 0,
        
//         // Expand/Collapse Icons
//         expandIcon: '+',
//         collapseIcon: '−',
//         iconColor: '#666666',
//         iconSize: 20,
//         iconWeight: '300',
        
//         // Hover Effects
//         qaItemHoverBackground: '#f8f9fa',
//         enableHoverEffects: true,
        
//         // Animation
//         animationDuration: 300, // milliseconds
//         enableSmoothTransitions: true,
        
//         // Custom Fonts
//         titleFont: '',
//         questionFont: '',
//         answerFont: '',
        
//         // Text Effects
//         titleEffect: '',
//         questionEffect: '',
//         answerEffect: '',
        
//         // Title Styling
//         titleColor: '#2c3e50',
//         titleSize: 36,
//         titleSizeMobile: 28,
//         titleSizeBig: 42,
//         titleWeight: '600',
//         titleWeightMobile: '600',
//         titleWeightBig: '600',
//         titleLineHeight: 1.2,
//         titleMarginBottom: 40,
//         titleAlignment: 'center', // Default: center alignment
        
//         // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//         height: 'auto',         // ✅ Auto Height basierend auf Content
//         heightMobile: 'auto',   // ✅ Auto Height auch auf Mobile
//         paddingTop: 30,         // ✅ Desktop Padding auf 30px
//         paddingTopMobile: 30,   // Mobile Padding
//         paddingBottom: 40,      // Desktop Padding
//         paddingBottomMobile: 30, // Mobile Padding
//         marginTop: 0,
//         marginBottom: 40,
//         borderRadius: 0,
        
//         // Layout System
//         qaLayout: 'classic-side-image', // Default Layout
        
//         // Layout Settings - NEW LAYOUT SYSTEM 2025
//         backgroundColor: '#ffffff',
//         titleContentSpacing: 40, // ✅ Spacing between title and Q&A content
//         imageMarginBottom: 20, // ✅ Bottom spacing below image
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // Responsive Settings
//         mobileImagePosition: 'top', // top|hidden
//         mobileImageHeight: 200,
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/qa.jpg',
//         id: '',
//         type: 'QAWidget',
//         name: 'Q&A Widget',
//         position: '16',
//         isSelected: false,
//         cat1: 'Info',
//         cat2: 'Interactive',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.qaWidget
//     },

//     holisticTestimonial: {
//         // Main Content
//         titleText: 'Hear it from others',
        
//         // Testimonials Array - 4 Cards Layout
//         testimonials: [
//             {
//                 id: 'testi1',
//                 text: 'Amazing Product that WORKS!!! I was pain free on my lower back within minutes. I bought 3 more and sent them to family in pain. That\'s how good it performs.',
//                 author: 'Carol G.',
//                 location: 'Salt Lake City, Utah',
//                 rating: 5,
//                 avatar: '/img/testi_1.jpg'
//             },
//             {
//                 id: 'testi2',
//                 text: 'I didn\'t believe that this would work but ordered it to try for my son-in-law who has a painful back for years. It worked amazingly!',
//                 author: 'Sharon A.',
//                 location: 'Salt Lake City, Utah',
//                 rating: 5,
//                 avatar: '/img/testi_2.jpg'
//             },
//             {
//                 id: 'testi3',
//                 text: 'Pain elimination within 10 minutes!',
//                 author: 'R.J.H.',
//                 location: 'Salt Lake City, Utah',
//                 rating: 5,
//                 avatar: '/img/testi_3.jpg'
//             },
//             {
//                 id: 'testi4',
//                 text: 'About 80% reduction in pain. Went from disabling to uncomfortable. I\'m getting my life back.',
//                 author: 'Louis P.',
//                 location: 'Salt Lake City, Utah',
//                 rating: 5,
//                 avatar: '/img/testi_5.jpg'
//             }
//         ],
        
        
//         // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//         height: 'auto',         // Desktop Height (auto für content-based)
//         heightMobile: 'auto',   // Mobile Height (auto für content-based)
//         paddingTop: 60,         // Desktop Padding
//         paddingTopMobile: 40,   // Mobile Padding
//         paddingBottom: 60,      // Desktop Padding
//         paddingBottomMobile: 40, // Mobile Padding
//         paddingLeft: 20,        // Desktop Horizontal Padding
//         paddingLeftMobile: 20,  // Mobile Horizontal Padding
//         marginTop: 0,
//         marginBottom: 40,
//         borderRadius: 0,
        
//         // Layout System
//         layoutType: 'linear-list', // linear-list|classic-grid|elegant-cards
//         cardStyle: 'linear-list', // Tracks which card style is currently active
        
//         // Text Alignment & Responsive
//         textAlignment: 'left',
//         textAlignmentMobile: 'left', // ✅ GEÄNDERT: Mobile auch left für linear-list
        
//         // ✅ TESTIMONIAL TEXT ALIGNMENT - Separate Controls für Testimonial-Inhalt
//         testimonialTextAlignment: 'left',        // Desktop Testimonial Text Alignment
//         testimonialTextAlignmentMobile: 'left',  // Mobile Testimonial Text Alignment
        
//         // Linear List Styling (like in the image)
//         showDividers: true,
//         dividerColor: '#e8e8e8',
//         dividerWidth: 1,
        
//         // Card Styling (Minimalistic like the image)
//         cardBackgroundColor: 'transparent',
//         cardBorderRadius: 0,
//         cardPadding: 32, // More inner padding for elegant spacing
//         cardShadow: false, // No shadows for minimalistic look
//         cardShadowColor: 'rgba(0, 0, 0, 0.08)',
//         cardBorder: false, // No card borders in linear list
//         cardBorderColor: '#e8e8e8', // Light gray thin lines
//         cardBorderWidth: 1,
//         cardSpacing: 0, // No spacing for seamless list
        
//         // Card Hover Effects (Subtle)
//         cardHoverShadow: false, // No hover shadows
//         cardHoverShadowColor: 'rgba(0, 0, 0, 0.12)',
//         cardHoverTransform: false, // No transform effects
//         cardHoverScale: 1.0,
//         cardHoverBackground: '#f5f5f5', // Subtle background change only
        
//         // Avatar Position (bottom|right)
//         avatarPosition: 'right', // Avatar right of name/platform like in image
        
//         // Star Rating Styling
//         starColor: '#ffd700',
//         starSize: 16,
//         starSpacing: 2,
//         showStars: true,
        
//         // Text Styling
//         testimonialTextColor: '#2c3e50',
//         testimonialTextSize: 15,
//         testimonialTextSizeMobile: 14,
//         testimonialTextSizeBig: 16,
//         testimonialTextWeight: '400',
//         testimonialTextLineHeight: 1.5,
        
//         authorNameColor: '#2c3e50',
//         authorNameSize: 14,
//         authorNameSizeMobile: 13,
//         authorNameSizeBig: 15,
//         authorNameWeight: '600',
        
//         authorLocationColor: '#666666',
//         authorLocationSize: 13,
//         authorLocationSizeMobile: 12,
//         authorLocationSizeBig: 14,
//         authorLocationWeight: '400',
        
//         // Avatar Styling
//         avatarSize: 48,
//         avatarBorderRadius: 50, // Percentage for circle
//         avatarBorder: true,
//         avatarBorderColor: '#e0e0e0',
//         avatarBorderWidth: 2,
//         showAvatars: true,
        
//         // Title Styling
//         titleColor: '#2c3e50',
//         titleSize: 42,
//         titleSizeMobile: 32,
//         titleSizeBig: 48,
//         titleWeight: '600',
//         titleLineHeight: 1.2,
//         titleMarginBottom: 48,
//         titleAlignment: 'left', // left|center|right
        
        
//         // ✅ RESPONSIVE AVATAR & STARS PROPERTIES
//         avatarSize: 48,
//         avatarSizeMobile: 40, // ✅ Mobile Avatar Size
//         starSize: 14,
//         starSizeMobile: 12, // ✅ Mobile Star Size
//         starSpacing: 2,
//         starSpacingMobile: 1, // ✅ Mobile Star Spacing
        
//         // Custom Fonts
//         titleFont: '',
//         testimonialTextFont: '',
//         authorNameFont: '',
//         authorLocationFont: '',
        
//         // Text Effects
//         titleEffect: '',
//         testimonialTextEffect: '',
        
//         // Basic Layout
//         backgroundColor: '#faf9f7', // Warm background like linear-list style
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // Grid Configuration
//         cardsPerRow: 1, // All testimonials stacked vertically
//         cardsPerRowTablet: 1, // All testimonials stacked vertically  
//         cardsPerRowMobile: 1, // All testimonials stacked vertically
//         contentMaxWidth: 1200,
        
//         // Visibility Toggles
//         showTitleText: true,
//         showStars: true,
//         showAvatars: true,
        
//         // Animation Settings
//         enableCardAnimations: true,
//         cardAnimationDelay: 100, // milliseconds between card animations
//         cardAnimationDuration: 600,
//         cardAnimationType: 'fadeInUp', // fadeInUp|slideInUp|scaleIn
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/holistic_testimonial.jpg',
//         id: '',
//         type: 'HolisticTestimonial',
//         name: 'Holistic Testimonial',
//         position: '17',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Social Proof',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.holisticTestimonial
//     },


//     bragBar: {
//         // Main Content
//         titleText: 'As seen on',
//         showTitle: true,
        
//         // Logos Array - Gleiche Reihenfolge wie HolisticTestimonial
//         logos: [
//             {
//                 id: 'logo1',
//                 image: '/img/today-show.png',
//                 alt: 'Today Show',
//                 link: '', // Optional link
//                 width: '', // Optional custom width
//                 height: '' // Optional custom height
//             },
//             {
//                 id: 'logo2',
//                 image: '/img/buzzfeed.png',
//                 alt: 'BuzzFeed',
//                 link: '',
//                 width: '',
//                 height: ''
//             },
//             {
//                 id: 'logo3',
//                 image: '/img/tnw.png',
//                 alt: 'TNW',
//                 link: '',
//                 width: '',
//                 height: ''
//             },
//             {
//                 id: 'logo4',
//                 image: '/img/wavy.png',
//                 alt: 'Wavy',
//                 link: '',
//                 width: '',
//                 height: ''
//             }
//         ],
        
//         // Logo Styling
//         logoHeight: 40, // Default height for all logos
//         logoMaxWidth: 150, // Maximum width to prevent oversized logos
//         logoSpacing: 40, // Space between logos
//         logoOpacity: 0.7, // Default opacity
//         logoHoverOpacity: 1.0, // Opacity on hover
//         logoFilter: 'grayscale(100%)', // Default filter (grayscale, none, etc.)
//         logoHoverFilter: 'grayscale(0%)', // Filter on hover
        
//         // Logo Alignment & Layout
//         logoAlignment: 'center', // left|center|right|space-between|space-around
//         logoVerticalAlignment: 'center', // top|center|bottom
//         logosPerRow: 5, // How many logos per row on desktop
//         logosPerRowTablet: 3, // Tablet
//         logosPerRowMobile: 2, // Mobile
        
//         // Logo Container Styling
//         logoContainerBackground: 'transparent',
//         logoContainerBorder: false,
//         logoContainerBorderColor: '#e0e0e0',
//         logoContainerBorderRadius: 8,
//         logoContainerPadding: 20,
//         logoContainerShadow: false,
//         logoContainerShadowColor: 'rgba(0, 0, 0, 0.05)',
        
//         // Hover Effects
//         enableHoverEffects: true,
//         hoverScale: 1.05, // Scale factor on hover
//         hoverTransition: 'all 0.3s ease',
        
//         // Title Styling
//         titleColor: '#666666',
//         titleSize: 16,
//         titleSizeMobile: 14,
//         titleSizeBig: 18,
//         titleWeight: '400',
//         titleLineHeight: 1.2,
//         titleMarginBottom: 30,
//         titleAlignment: 'center', // left|center|right
//         titleLetterSpacing: 1, // Spacing for elegant look
//         titleUppercase: true, // Transform to uppercase
        
//         // Custom Fonts
//         titleFont: '',
        
//         // Text Effects
//         titleEffect: '',
        
//         // Layout Settings
//         backgroundColor: '#ffffff',
//         height: 200, // Compact height for brag bar
//         padding: 40,
//         contentMaxWidth: 1200,
//         borderRadius: 0,
//         marginTop: 0,
//         marginBottom: 0,
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // 🚀 STANDARD LAYOUT PROPERTIES (Revolutionary Layout System)
//         // Spacing - Desktop
//         paddingTop: 40,
//         paddingBottom: 40,
        
//         // Spacing - Mobile
//         paddingTopMobile: 30,
//         paddingBottomMobile: 30,
        
//         // Height Dimensions - Desktop
//         minHeight: 0,
        
//         // Height Dimensions - Mobile
//         heightMobile: 'auto',
//         minHeightMobile: 0,
        
//         // Responsive Settings
//         mobilePadding: 30,
//         tabletPadding: 35,
//         mobileLogoSpacing: 25,
//         tabletLogoSpacing: 30,
//         mobileLogoHeight: 32,
//         tabletLogoHeight: 36,
        
//         // Animation Settings
//         enableAnimations: true,
//         logoAnimationDelay: 100, // milliseconds between logo animations
//         logoAnimationDuration: 600,
//         logoAnimationType: 'fadeIn', // fadeIn|slideInUp|scaleIn
        
//         // Advanced Options
//         enableInfiniteScroll: false, // For very long logo lists
//         scrollSpeed: 30, // seconds for full scroll cycle
//         pauseOnHover: true, // Pause scroll on hover
        
//         // Logo Link Behavior
//         logoLinkTarget: '_blank', // _blank|_self
//         enableLogoLinks: true,
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/bragbar.jpg',
//         id: '',
//         type: 'BragBar',
//         name: 'Brag Bar',
//         position: '19',
//         isSelected: false,
//         cat1: 'Marketing',
//         cat2: 'Logos',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.bragBar
//     },

//     spiritualFeatureBanner: {
//         // ✅ NEW LAYOUT SYSTEM 2025 - Responsive Properties
//         height: 'auto',                  // Auto height für natürliche Proportionen
//         heightMobile: 'auto',            // Auto height Mobile für natürliche Proportionen
//         paddingTop: 80,                  // Desktop padding
//         paddingTopMobile: 40,            // Mobile padding
//         paddingBottom: 80,               // Desktop padding
//         paddingBottomMobile: 40,         // Mobile padding
//         marginTop: 0,                    // Standard margin
//         marginBottom: 0,                 // Standard margin
//         borderRadius: 0,                 // Standard border radius
        
//         // ✅ LAYOUT SYSTEM
//         layoutType: 'classic-center',    // Default Layout für Layout-Variations
        
//         // ✅ FEATURE VISIBILITY TOGGLES
//         showFeature1: true,              // Feature 1 visible by default
//         showFeature2: true,              // Feature 2 visible by default
//         showFeature3: true,              // Feature 3 visible by default
//         showFeature4: true,              // Feature 4 visible by default
        
//         // Layout Configuration (Legacy - wird durch layoutType ersetzt)
//         layoutStyle: 'classic-center', // classic-center, image-top-vertical, image-top-horizontal
        
//         // Animation Settings
//         enableAnimations: false,
//         animationType: 'fadeInUp', // fadeInUp, slideInLeft, fadeIn, elegantScale
//         animationDuration: 600, // ms
//         animationDelay: 200, // ms between features
        
//         // Center Image
//         centerImage: '/img/lady_yoga.png',
//         showCenterImage: true,
//         centerImageWidth: 300, // Fixed width for center image
//         centerImageHeight: 500, // Fixed height for center image
//         centerImageBorderRadius: 12,
//         centerImageFit: 'cover', // cover|contain|fill
//         centerImageShadow: true,
//         centerImageShadowColor: 'rgba(0, 0, 0, 0.1)',
        
//         // Features Array - Exactly 4 features (2 left, 2 right)
//         features: [
//             {
//                 id: 'feature1',
//                 position: 'left', // left|right
//                 title: 'Growth & self discovery',
//                 description: 'Yoga is an enriching opportunity for personal growth and self-discovery. That\'s why we offer classes focusing on themes like stress reduction, relaxation, and self-awareness.',
//                 titleSize: 32,
//                 descriptionSize: 16
//             },
//             {
//                 id: 'feature2',
//                 position: 'left',
//                 title: 'All levels welcome',
//                 description: 'Yoga is a transformative journey, an opportunity for personal growth, emotional healing, and self-discovery. That\'s why we offer a diverse array of classes tailored to all skill levels.',
//                 titleSize: 32,
//                 descriptionSize: 16
//             },
//             {
//                 id: 'feature3',
//                 position: 'right',
//                 title: 'Breath & stillness',
//                 description: 'We also incorporate breathwork and meditation to help individuals connect deeply with their breath, cultivate awareness, and reduce tension and anxiety.',
//                 titleSize: 32,
//                 descriptionSize: 16
//             },
//             {
//                 id: 'feature4',
//                 position: 'right',
//                 title: 'Beyond boundaries',
//                 description: 'We provide inclusive and holistic yoga lessons, expertly exploring diverse topics, styles, and techniques to support overall physical, mental, and spiritual wellbeing effectively.',
//                 titleSize: 32,
//                 descriptionSize: 16
//             }
//         ],
        
//         // Feature Styling
//         featureTitleColor: '#2c3e50',
//         featureTitleSize: 32,
//         featureTitleSizeMobile: 24,
//         featureTitleSizeBig: 36,
//         featureTitleWeight: '400', // Light weight for spiritual feel
//         featureTitleLineHeight: 1.2,
//         featureTitleMarginBottom: 16,
        
//         featureDescriptionColor: '#5a5a5a',
//         featureDescriptionSize: 16,
//         featureDescriptionSizeMobile: 14,
//         featureDescriptionSizeBig: 18,
//         featureDescriptionWeight: '400',
//         featureDescriptionLineHeight: 1.6,
        
//         // Feature Container Styling
//         featureSpacing: 20, // Space between title and description
//         featureVerticalSpacing: 60, // Space between features on same side
//         sideSpacing: 60, // Space between sides and center image
        
//         // Custom Fonts
//         featureTitleFont: '',
//         featureDescriptionFont: '',
        
//         // Text Effects
//         featureTitleEffect: '',
//         featureDescriptionEffect: '',
        
//         // Layout Settings
//         backgroundColor: '#f9f8f6', // Warm, spiritual background
//         height: 1000,
//         padding: 80, // Generous padding for elegant feel
//         contentMaxWidth: 1400, // Wide for 3-column layout
//         borderRadius: 0,
//         marginTop: 0,
//         marginBottom: 0,
//         border: false,
//         borderColor: '#e2e8f0',
//         borderWidth: 1,
        
//         // 🚀 REVOLUTIONARY LAYOUT SYSTEM - Standard Properties
//         // Spacing - Desktop
//         paddingTop: 80,
//         paddingBottom: 80,
//         marginTop: 0,
//         marginBottom: 40,
        
//         // Spacing - Mobile
//         paddingTopMobile: 40,
//         paddingBottomMobile: 40,
//         marginTopMobile: 0,
//         marginBottomMobile: 20,
        
//         // Height Dimensions - Desktop
//         height: 'auto',
//         minHeight: 600,
//         // maxHeight: '', // Optional
        
//         // Height Dimensions - Mobile
//         heightMobile: 'auto',
//         minHeightMobile: 1850, // Speziell für SpiritualFeatureBanner - hoher Wert für mobile Layouts
//         // maxHeightMobile: '', // Optional
        
//         // Responsive Settings
//         mobilePadding: 40,
//         tabletPadding: 60,
//         mobileLayout: 'vertical', // vertical layout for all devices
//         tabletLayout: 'vertical', // vertical layout for all devices
//         desktopLayout: 'vertical', // vertical layout for all devices
        
//         // Animation Settings
//         enableAnimations: true,
//         featureAnimationDelay: 200, // milliseconds between feature animations
//         featureAnimationDuration: 800,
//         featureAnimationType: 'fadeInUp', // fadeInUp|slideInLeft|slideInRight
//         imageAnimationDelay: 400, // Image appears after features
        
//         // Advanced Styling
//         enableParallax: false, // Subtle parallax effect on scroll
//         textAlignment: 'left', // left|center|justify
//         featureAlignment: 'top', // top|center|bottom (vertical alignment of feature blocks)
        
//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/spiritual_feature_banner.jpg',
//         id: '',
//         type: 'SpiritualFeatureBanner',
//         name: 'Spiritual Feature Banner',
//         position: '20',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Features',
        
//         // AI Integration
//     aiInfo: aiWidgetInfos.spiritualFeatureBanner
// },

// // Fancy Footer Widget - Multifunctional Premium Footer
// fancyFooter: {
//     // Logo & Branding
//     logoImage: '/img/your-logo.webp',
//     showLogo: true,
//     logoWidth: 120,
//     logoHeight: 60,
//     logoInvert: true, // Color invert standardmäßig aktiv
//     companyName: 'Your Company',
//     slogan: 'Your inspiring slogan here',
    
//     // Contact Information
//     showContactInfo: true,
//     address: '123 Business Street\nYour City, State 12345',
//     phone: '+1 (555) 123-4567',
//     email: 'contact@yourcompany.com',
    
//     // Navigation Categories
//     showNavigation: true,
//     categories: [
//         {
//             id: 'cat1',
//             title: 'Services',
//             links: [
//                 { text: 'Our Services', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'Portfolio', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'Contact', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'External Link', type: 'url', targetWidgetId: '', url: 'https://example.com' }
//             ]
//         },
//         {
//             id: 'cat2',
//             title: 'Company',
//             links: [
//                 { text: 'About Us', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'Team', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'Careers', type: 'url', targetWidgetId: '', url: '#' },
//                 { text: 'Press', type: 'url', targetWidgetId: '', url: '#' }
//             ]
//         },
//         {
//             id: 'cat3',
//             title: 'Resources',
//             links: [
//                 { text: 'Blog', type: 'url', targetWidgetId: '', url: 'https://blog.example.com' },
//                 { text: 'Documentation', type: 'url', targetWidgetId: '', url: '#' },
//                 { text: 'Help Center', type: 'widget', targetWidgetId: '', url: '#' },
//                 { text: 'Community', type: 'url', targetWidgetId: '', url: '#' }
//             ]
//         }
//     ],
    
//     // Social Media Links
//     showSocialLinks: true,
//     socialIconStyle: 'dark-outline', // ✅ GEÄNDERT: dark-outline als Standard, AI wählt automatisch light-outline für dunkle Hintergründe
//     socialLinks: [
//         { platform: 'facebook', url: 'https://facebook.com/yourcompany' },
//         { platform: 'instagram', url: 'https://instagram.com/yourcompany' },
//         { platform: 'linkedin', url: 'https://linkedin.com/company/yourcompany' },
//         { platform: 'youtube', url: 'https://youtube.com/@yourcompany' }
//     ],
    
//     // Newsletter Signup (DISABLED)
//     showNewsletter: false,
//     newsletterTitle: 'Stay Updated',
//     newsletterDescription: 'Subscribe to our newsletter for the latest updates and insights.',
//     newsletterButtonText: 'Subscribe',
//     newsletterPlaceholder: 'Enter your email',
    
//     // Bottom Bar
//     showBottomBar: true,
//     copyrightText: '© 2025 Your Company. All rights reserved.',
//     showLegalLinks: true,
//     legalLinks: [
//         { text: 'Privacy Policy', url: '#' },
//         { text: 'Terms of Service', url: '#' },
//         { text: 'Imprint', url: '#' }
//     ],
    
//     // Styling Properties - SPACE SETTINGS KOMPATIBEL
//     backgroundColor: '', // Wird von Space Settings gesetzt
//     textColor: '',       // Wird von Space Settings gesetzt
//     headingColor: '',    // Wird von Space Settings gesetzt  
//     linkColor: '',       // Wird von Space Settings gesetzt
//     linkHoverColor: '',  // Wird von Space Settings gesetzt
//     accentColor: '',     // Wird von Space Settings gesetzt
    
//     // Layout Configuration
//     layoutType: 'corporate-layout', // corporate-layout, modern-layout, minimal-layout, creative-layout
    
//     // Typography
//     headingFont: '',
//     bodyFont: '',
//     headingSize: 18,
//     headingSizeMobile: 16,
//     headingSizeBig: 20,
//     headingWeight: '600',
//     headingEffect: '',
    
//     bodySize: 14,
//     bodySizeMobile: 13,
//     bodySizeBig: 15,
//     bodyWeight: '400',
//     bodyEffect: '',
    
//     sloganSize: 16,
//     sloganSizeMobile: 14,
//     sloganSizeBig: 18,
//     sloganWeight: '400',
//     sloganEffect: '',
    
//     // Spacing & Dimensions
//     paddingTop: 60,
//     paddingBottom: 40,
//     paddingX: 40,
//     columnGap: 40,
//     rowGap: 30,
    
//     // 🚀 REVOLUTIONARY LAYOUT SYSTEM - Standard Properties
//     // Spacing - Desktop
//     paddingTop: 60,
//     paddingBottom: 40,
//     marginTop: 0,
//     marginBottom: 0,
    
//     // Spacing - Mobile
//     paddingTopMobile: 40,
//     paddingBottomMobile: 30,
//     marginTopMobile: 0,
//     marginBottomMobile: 0,
    
//     // Height Dimensions - Desktop
//     height: 'auto',
//     minHeight: 200,
//     // maxHeight: '', // Optional
    
//     // Height Dimensions - Mobile
//     heightMobile: 'auto',
//     minHeightMobile: 150,
//     // maxHeightMobile: '', // Optional
    
//     // Custom Footer Properties (for Revolutionary Layout Settings)
//     logoHeight: 60,
//     columnSpacing: 40,
//     sectionSpacing: 30,
//     socialIconSize: 20,
//     socialIconSpacing: 12,
    
//     // Bottom Bar Styling (AI-Colors haben Priorität!)
//     // bottomBarBackground, bottomBarTextColor werden jetzt dynamisch von AI-Design-System gesetzt!
//     bottomBarPadding: 20,
    
//     // Advanced Styling
//     borderTop: false,
//     // borderTopColor wird jetzt dynamisch von AI-Design-System gesetzt!
//     borderTopWidth: 1,
    
//     // Widget Meta (REQUIRED)
//     imagePreview: '/img/fancy_footer.jpg',
//     id: '',
//     type: 'FancyFooter',
//     name: 'Fancy Footer',
//     position: '50',
//     isSelected: false,
//     cat1: 'Fancy',
//     cat2: 'Basic',
    
//     // AI Integration (REQUIRED)
//     aiInfo: aiWidgetInfos.fancyFooter
//     },

//     // ========================================
//     // SIMPLISTIC SERVICES WIDGET
//     // ========================================
//     simplicisticServices: {
//         // Main Content
//         titleText: 'Our Services',
//         subtitleText: 'Discover our comprehensive range of professional services designed to help you achieve your goals.',
        
//         // ✅ HIGHLIGHT-SYSTEM für titleText
//         titleHighlightWords: '', // Komma-getrennte Wörter zum Highlighten
//         titleHighlightFont: '', // Font für highlighted Wörter (leer = anderer Font)
//         titleHighlightColor: '#D4A574', // Farbe für highlighted Wörter
//         titleHighlightWeight: '800', // Font-Weight für highlighted Wörter
//         titleHighlightEffect: '', // Text-Effect für highlighted Wörter
//         titleHighlightSize: 32, // Desktop Font-Größe (gleich wie titleSize)
//         titleHighlightSizeMobile: 28, // Mobile Font-Größe (gleich wie titleSizeMobile)
//         titleHighlightSizeBig: 36, // Big Screen Font-Größe (gleich wie titleSizeBig)
//         titleHighlightMarginLeft: 0, // Margin Links für Highlight Words (-50px bis +50px)
//         titleHighlightMarginRight: 0, // Margin Rechts für Highlight Words (-50px bis +50px)
        
//         // Custom Fonts (optional - falls leer wird globalFont verwendet)
//         titleFont: '',
//         subtitleFont: '',
//         serviceNameFont: '',
//         serviceDescriptionFont: '',
        
//         // Text Effects (optional - falls leer wird kein Effekt angewendet)
//         titleEffect: '',
//         subtitleEffect: '',
        
//         // Main Text Colors & Sizes
//         titleColor: '#000000',
//         titleSize: 32,
//         titleSizeMobile: 28,
//         titleSizeBig: 36,
//         titleWeight: '600',
        
//         subtitleColor: '#666666',
//         subtitleSize: 18,
//         subtitleSizeMobile: 16,
//         subtitleSizeBig: 20,
//         subtitleWeight: '400',
        
//         // ✅ TEXT SPACING
//         titleBottomMargin: 16, // Abstand zwischen Titel und Subtitle
        
//         // Services Array - dynamisch erweiterbar
//         services: [
//             {
//                 name: 'Web Development',
//                 description: 'Custom websites and web applications built with modern technologies for optimal performance and user experience.',
//                 price: '$2,500', // ✅ PRICE FIELD
//                 icon: '/img/icons/handdrawn/internet.svg', // Icon aus IconPicker oder Upload
//                 iconType: 'picker', // 'picker' oder 'upload'
//                 customIcon: '', // Für hochgeladene Icons
//                 visible: true, // ✅ VISIBILITY TOGGLE - standardmäßig sichtbar
//                 useImage: false, // ✅ NEUES SYSTEM: false = Icon, true = Image
//                 serviceImage: '', // ✅ SERVICE IMAGE URL
//                 // ✅ BUTTON SYSTEM - NEU
//                 buttonText: 'Learn More', // Button-Text
//                 buttonLink: '#', // Button-Link
//                 showButton: true // Button-Sichtbarkeit Toggle
//             },
//             {
//                 name: 'Digital Marketing',
//                 description: 'Comprehensive digital marketing strategies to boost your online presence and drive meaningful results.',
//                 price: '$1,200/mo', // ✅ PRICE FIELD
//                 icon: '/img/icons/handdrawn/paper-plane.svg',
//                 iconType: 'picker',
//                 customIcon: '',
//                 visible: true, // ✅ VISIBILITY TOGGLE - standardmäßig sichtbar
//                 useImage: false, // ✅ NEUES SYSTEM: false = Icon, true = Image
//                 serviceImage: '', // ✅ SERVICE IMAGE URL
//                 // ✅ BUTTON SYSTEM - NEU
//                 buttonText: 'Get Started', // Button-Text
//                 buttonLink: '#contact', // Button-Link
//                 showButton: true // Button-Sichtbarkeit Toggle
//             },
//             {
//                 name: 'Brand Design',
//                 description: 'Professional brand identity design including logos, colors, and visual guidelines for consistent branding.',
//                 price: '$800', // ✅ PRICE FIELD
//                 icon: '/img/icons/handdrawn/feather.svg',
//                 iconType: 'picker',
//                 customIcon: '',
//                 visible: true, // ✅ VISIBILITY TOGGLE - standardmäßig sichtbar
//                 useImage: false, // ✅ NEUES SYSTEM: false = Icon, true = Image
//                 serviceImage: '', // ✅ SERVICE IMAGE URL
//                 // ✅ BUTTON SYSTEM - NEU
//                 buttonText: 'View Portfolio', // Button-Text
//                 buttonLink: '/portfolio', // Button-Link
//                 showButton: true // Button-Sichtbarkeit Toggle
//             },
//             {
//                 name: 'Consulting',
//                 description: 'Expert business consulting to help you make informed decisions and optimize your operations.',
//                 price: '$150/hr', // ✅ PRICE FIELD
//                 icon: '/img/icons/handdrawn/trophy.svg',
//                 iconType: 'picker',
//                 customIcon: '',
//                 visible: true, // ✅ VISIBILITY TOGGLE - standardmäßig sichtbar
//                 useImage: false, // ✅ NEUES SYSTEM: false = Icon, true = Image
//                 serviceImage: '', // ✅ SERVICE IMAGE URL
//                 // ✅ BUTTON SYSTEM - NEU
//                 buttonText: 'Book Session', // Button-Text
//                 buttonLink: '/booking', // Button-Link
//                 showButton: true // Button-Sichtbarkeit Toggle
//             }
//         ],
        
//         // Service Card Styling
//         serviceBackgroundColor: '#ffffff',
//         serviceNameColor: '#000000',
//         serviceNameSize: 20,
//         serviceNameWeight: '600',
        
//         serviceDescriptionColor: '#666666',
//         serviceDescriptionSize: 16,
//         serviceDescriptionWeight: '400',
        
//         // Service Price Settings
//         servicePriceColor: '#10b981', // Grüne Farbe für Preise
//         servicePriceSize: 18,
//         servicePriceSizeMobile: 16,
//         servicePriceWeight: '600',
//         showServicePrices: true, // Toggle für Price-Anzeige
        
//         // ✅ SERVICE BUTTON SETTINGS - NEU
//         serviceButtonColor: '#667eea', // Button Hintergrund-Farbe
//         serviceButtonTextColor: '#ffffff', // Button Text-Farbe
//         serviceButtonSize: 14, // Button Text-Größe
//         serviceButtonSizeMobile: 13, // Button Text-Größe Mobile
//         serviceButtonWeight: '500', // Button Text-Gewicht
//         serviceButtonFont: '', // Button Font (leer = verwendet serviceDescriptionFont)
//         serviceButtonPadding: 12, // Button innen-Padding (vertikal)
//         serviceButtonPaddingHorizontal: 24, // Button innen-Padding (horizontal)
//         serviceButtonWidth: 'auto', // Button Breite ('auto' oder px-Wert)
//         serviceButtonWidthMobile: 'auto', // Button Breite Mobile ('auto' oder px-Wert)
//         serviceButtonHeight: 'auto', // Button Höhe ('auto' oder px-Wert)
//         serviceButtonHeightMobile: 'auto', // Button Höhe Mobile ('auto' oder px-Wert)
//         serviceButtonWidthPx: 120, // Button Breite in Pixeln (für Slider)
//         serviceButtonWidthPxMobile: 120, // Button Breite Mobile in Pixeln (für Slider)
//         serviceButtonHeightPx: 44, // Button Höhe in Pixeln (für Slider)
//         serviceButtonHeightPxMobile: 40, // Button Höhe Mobile in Pixeln (für Slider)
//         serviceButtonBorderRadius: 8, // Button Border-Radius (0px = eckig, 50px = sehr rund)
//         serviceButtonBorder: false, // Button Border aktiviert/deaktiviert
//         serviceButtonBorderColor: '#667eea', // Button Border-Farbe
//         serviceButtonBorderWidth: 1, // Button Border-Breite (0px = kein Border)
//         serviceButtonHoverEffect: true, // Button Hover-Effekt
//         serviceButtonHoverColor: '#5a67d8', // Button Hover-Farbe
//         serviceButtonShadow: true, // Button Schatten
//         showServiceButtons: true, // Global Toggle für alle Service-Buttons
        
//         // Service Icon Settings
//         serviceIconSize: 60,
//         serviceIconColor: '#667eea', // Für SVG Icons
//         serviceIconBackgroundColor: 'rgba(102, 126, 234, 0.1)',
//         serviceIconBorderRadius: 12,
//         serviceIconPadding: 16,
//         serviceIconBorderWidth: 0, // Border width around icon containers (0px = kein Border, User kann anpassen)
        
//         // ✅ SERVICE IMAGE SIZE CONTROLS (Responsive)
//         serviceImageWidth: 60,
//         serviceImageHeight: 60,
//         serviceImageWidthMobile: 50,
//         serviceImageHeightMobile: 50,
//         invertIconColors: false, // Smart Icon Inversion Toggle - Standard AUS (normale Icons)
//         showServiceIcons: true, // Toggle to show/hide service icons
        
//         // Service Card Settings
//         serviceBorder: false,
//         serviceBorderColor: '#e5e5e5',
//         serviceBorderWidth: 1, // Border width for service cards
//         serviceBorderRadius: 16,
//         containerBorderColor: '#e5e5e5', // Border color for container top/bottom
//         servicePadding: 32,
//         servicePaddingHorizontal: 32, // Left and right padding inside service cards
//         serviceShadow: true,
//         serviceSpacing: 24, // Standard Gap zwischen Service Cards
        
//         // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//         height: 'auto',                 // ✅ AUTO HEIGHT: Passt sich an Content an
//         heightMobile: 'auto',           // ✅ AUTO HEIGHT: Mobile auch auto
//         minHeight: 0,                   // ✅ MIN HEIGHT: Flexible Höhe
//         minHeightMobile: 0,             // ✅ MIN HEIGHT: Flexible Mobile Höhe
//         paddingTop: 0,                  // ✅ ZERO PADDING: Edge-to-edge Design
//         paddingTopMobile: 0,            // ✅ ZERO PADDING: Mobile auch 0
//         paddingBottom: 0,               // ✅ ZERO PADDING: Edge-to-edge Design
//         paddingBottomMobile: 0,         // ✅ ZERO PADDING: Mobile auch 0
//         marginTop: 0,
//         marginBottom: 40,
//         borderRadius: 0,
        
//         // Layout System
//         layoutType: 'classic-grid',     // Default Layout
        
//         // Basic Layout
//         backgroundColor: '#ffffff',
//         border: false,
//         borderColor: '#CCCCCC',
        
//         // Content Width Settings
//         maxWidth: 1200,                 // Maximum width of widget content
//         maxWidthMobile: 1200,           // Mobile widget content max width
//         subtitleMaxWidth: 800,          // Maximum width of subtitle text
//         serviceTextMaxWidth: 0,    // Maximum width of service text container (0 = unlimited, px values)
//         serviceTextMaxWidthMobile: 0, // Maximum width of service text container on mobile (0 = unlimited, px values)
//         serviceTextMinHeight: 0,    // Minimum height of service text container (0 = auto height, px values)
//         serviceTextMinHeightMobile: 0, // Minimum height of service text container on mobile (0 = auto height, px values)
//         serviceDescriptionMinHeight: 0, // Minimum height of description text (0 = auto height, px values)
//         serviceDescriptionMinHeightMobile: 0, // Minimum height of description text on mobile (0 = auto height, px values)
//         serviceImageShadow: false, // Shadow for service images (true/false)
//         serviceImageTopMargin: 0, // Top margin above service images (px values)
//         serviceImageTopMarginMobile: 0, // Top margin above service images on mobile (px values)
        
//         // Service Layout Options
//         serviceLayout: 'classic-grid', // 'classic-grid', 'masonry-flow', 'luxury-cards', 'glass-panels', 'icon-top', 'icon-left'
        
//         // Grid Settings
//         servicesPerRow: 2, // 2, 3, 4 (responsive)
//         servicesPerRowMobile: 1,
        
//         // Hover Effects
//         serviceHoverEffect: true,
//         serviceHoverScale: 1.02,
//         serviceHoverShadow: true,
        
//         // Content Spacing Settings
//         contentSpacing: 40,        // Side spacing around service components (desktop)
//         contentSpacingMobile: 20,  // Side spacing around service components (mobile)
//         serviceMinHeight: 330,     // Minimum height for service cards
        
//         // Widget Meta
//         imagePreview: '/img/simply_services.jpg',
//         id: '',
//         type: 'SimplisticServices',
//         name: 'Simplistic Services',
//         position: '1',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Button',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.simplicisticServices
//     },

//     // ========================================
//     // BULLET POINTS WIDGET
//     // ========================================
//     bulletPointsWidget: {
//         // Main Content
//         titleText: 'Key Benefits',
        
//         // Custom Fonts (optional - falls leer wird globalFont verwendet)
//         titleFont: '',
//         bulletPointFont: '',
        
//         // Text Effects (optional - falls leer wird kein Effekt angewendet)
//         titleEffect: '',
        
//         // Main Text Colors & Sizes
//         titleColor: '#000000',
//         titleSize: 36,
//         titleSizeMobile: 28,
//         titleSizeBig: 42,
//         titleWeight: '700',
        
//         // Bullet Points Array - dynamisch erweiterbar mit Rich Text
//         bulletPoints: [
//             {
//                 id: 'bp1',
//                 richText: '<strong>Professional Results</strong> - Get measurable outcomes that drive real business growth and success.',
//                 icon: '/img/icons/handdrawn/trophy.svg', // Icon aus IconPicker oder Upload
//                 iconType: 'picker', // 'picker' oder 'upload'
//                 customIcon: '' // Für hochgeladene Icons
//             },
//             {
//                 id: 'bp2',
//                 richText: '<strong>Expert Guidance</strong> - Work with experienced professionals who understand your industry and challenges.',
//                 icon: '/img/icons/handdrawn/star.svg',
//                 iconType: 'picker',
//                 customIcon: ''
//             },
//             {
//                 id: 'bp3',
//                 richText: '<strong>Proven Process</strong> - Follow our tested methodology that has helped hundreds of clients achieve their goals.',
//                 icon: '/img/icons/handdrawn/diamond.svg',
//                 iconType: 'picker',
//                 customIcon: ''
//             },
//             {
//                 id: 'bp4',
//                 richText: '<strong>Ongoing Support</strong> - Receive continuous support and guidance throughout your entire journey with us.',
//                 icon: '/img/icons/handdrawn/reward.svg',
//                 iconType: 'picker',
//                 customIcon: ''
//             }
//         ],
        
//         // Bullet Point Styling
//         bulletSymbol: '▶', // Symbol für minimal Layout
//         bulletPointMinHeight: 60, // Mindesthöhe für Bullet Points
//         bulletPointColor: '#333333',
//         bulletPointSize: 16,
//         bulletPointWeight: '400',
//         bulletPointLineHeight: 1.6,
        
//         // Bullet Point Icon Settings
//         bulletIconSize: 48,
//         bulletIconColor: '#667eea', // Für SVG Icons
//         bulletIconBackgroundColor: 'rgba(102, 126, 234, 0.1)',
//         bulletIconBorderRadius: 12,
//         bulletIconPadding: 12,
//         invertIconColors: false, // Toggle für Icon-Color-Inversion
        
//         // Bullet Point Layout
//         bulletPointSpacing: 24,
//         bulletPointPadding: 20,
//         bulletPointAlignment: 'left', // 'left', 'center'
//         bulletPointDirection: 'vertical', // 'vertical', 'horizontal'
        
//         // Background Image System (wie SupremeTestimonial)
//         backgroundImage: '/img/crowd.jpg',
//         backgroundImageOpacity: 10, // Prozent-Wert für neue ImageContainer
//         imageEffect: 'blur', // none|blur|grayscale|top-fade|etc.
//         showBackgroundImage: false,
        
//         // Layout
//         backgroundColor: '#ffffff',
//         height: 'auto',
//         contentSpacing: 40,
//         maxWidth: 1000, // Maximum width of widget content
//         borderRadius: 0,
//         marginTop: 0,
//         marginBottom: 0,
        
//         // 🚀 STANDARD LAYOUT PROPERTIES (Revolutionary Layout System)
//         // Spacing - Desktop
//         paddingTop: 80,
//         paddingBottom: 80,
        
//         // Spacing - Mobile
//         paddingTopMobile: 40,
//         paddingBottomMobile: 40,
        
//         // Height Dimensions - Desktop
//         minHeight: 0,
        
//         // Height Dimensions - Mobile
//         heightMobile: 'auto',
//         minHeightMobile: 0,
//         border: false,
//         borderColor: '#CCCCCC',
        
//         // Bullet Point Layout Options
//         bulletLayout: 'icon-left', // 'icon-left', 'icon-top', 'icon-right', 'numbered', 'minimal', 'clean-icon'
        
//         // Grid Settings
//         bulletPointsPerRow: 2, // 1, 2 (responsive)
//         bulletPointsPerRowMobile: 1,
        
//         // Widget Meta
//         imagePreview: '/img/bullet.jpg',
//         id: '',
//         type: 'BulletPointsWidget',
//         name: 'Bullet Points',
//         position: '1',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Basic',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.bulletPointsWidget
//     },

//     // ========================================
//     // COMPARISON WIDGET (Before/After)
//     // ========================================
//     comparisonWidget: {
//         // Main Content
//         titleText: 'Your Transformation Journey',
        
//         // Rich Text Content (links)
//         richTextContent: '<p>Your life, as it is now, is not the truth of what is destined for you. Perhaps you have felt it for a long time: that more is ready for you, that you are not here to adapt, to make yourself small or to continue turning in circles.</p><p>Instead, to live in your full greatness. My guidance - whether 1:1 or 2:2 - are not classic solutions, no superficial solutions. It is about <strong>healing</strong> what has been between you and your health & fulfillment so far.</p>',
        
//         // Before/After Images
//         beforeImage: '/img/photo_card_2.jpg', // Before Placeholder
//         afterImage: '/img/photo_card_1.jpg', // After Placeholder
        
//         // Image Labels
//         beforeLabel: 'Before',
//         afterLabel: 'After',
//         beforeDate: 'January 2023',
//         afterDate: 'September 2024',
        
//         // Custom Fonts (optional - falls leer wird globalFont verwendet)
//         titleFont: '',
//         richTextFont: '',
//         imageLabelFont: '',
        
//         // Text Effects (optional - falls leer wird kein Effekt angewendet)
//         titleEffect: '',
        
//         // Main Text Colors & Sizes
//         titleColor: '#000000',
//         titleSize: 42,
//         titleSizeMobile: 32,
//         titleSizeBig: 48,
//         titleWeight: '700',
        
//         // Rich Text Styling
//         richTextColor: '#333333',
//         richTextSize: 16,
//         richTextWeight: '400',
//         richTextLineHeight: 1.6,
        
//         // Image Label Styling
//         imageLabelColor: '#666666',
//         imageLabelSize: 14,
//         imageLabelWeight: '600',
//         imageLabelBackgroundColor: 'rgba(255, 255, 255, 0.9)',
//         imageLabelPadding: 8,
//         imageLabelBorderRadius: 6,
        
//         // Before Image Settings
//         beforeImageWidth: 240,
//         beforeImageHeight: 300,
//         beforeImageBorderRadius: 12,
//         beforeImageShadow: true,
        
//         // After Image Settings
//         afterImageWidth: 240,
//         afterImageHeight: 300,
//         afterImageBorderRadius: 12,
//         afterImageShadow: true,
        
//         // General Image Settings
//         imageSpacing: 20, // Space between images (side-by-side mode)
//         imageOverlap: 185, // Desktop diagonal overlap
        
//         // Mobile-specific Settings
//         mobileLayoutStyle: 'vertical-overlap', // 'vertical-overlap', 'separated', 'side-by-side'
//         mobileImageOverlap: 235, // Mobile vertical overlap
//         mobileImageMaxWidth: 280, // Mobile max width
//         mobileImageHeight: 270, // Mobile height
        
//         // Legacy support (fallback for existing widgets)
//         imageWidth: 240,
//         imageHeight: 300,
//         imageBorderRadius: 12,
//         imageShadow: true,
        
//         // Layout Settings
//         backgroundColor: '#ffffff',
//         height: 500,
//         padding: 60,
//         contentSpacing: 60, // Space between text and images
//         maxWidth: 1200,
//         borderRadius: 0,
//         marginTop: 0,
//         marginBottom: 0,
//         border: false,
//         borderColor: '#CCCCCC',
        
//         // 🚀 REVOLUTIONARY LAYOUT SYSTEM - Standard Properties
//         // Spacing - Desktop
//         paddingTop: 60,
//         paddingBottom: 60,
//         marginTop: 0,
//         marginBottom: 40,
        
//         // Spacing - Mobile
//         paddingTopMobile: 40,
//         paddingBottomMobile: 40,
//         marginTopMobile: 0,
//         marginBottomMobile: 20,
        
//         // Height Dimensions - Desktop
//         height: 500,
//         minHeight: 400,
//         // maxHeight: '', // Optional
        
//         // Height Dimensions - Mobile
//         heightMobile: 'auto',
//         minHeightMobile: 350,
//         // maxHeightMobile: '', // Optional
        
//         // Custom Image Properties (for Revolutionary Layout Settings)
//         imageWidth: 240,
//         imageHeight: 300,
//         imageOverlap: 25,
//         imageBorderRadius: 12,
        
//         // Content Spacing Settings
//         contentSpacing: 40,        // Side spacing around transformation content (desktop)
//         contentSpacingMobile: 20,  // Side spacing around transformation content (mobile)
        
//         // Layout Options
//         comparisonLayout: 'text-left-images-right', // 'text-left-images-right', 'text-right-images-left', 'text-top-images-bottom'
//         textAlignment: 'left', // 'left', 'center', 'right'
//         imageAlignment: 'center', // 'top', 'center', 'bottom'
        
//         // Responsive Settings
//         mobileLayout: 'stacked', // 'stacked', 'side-by-side'
        
//         // Widget Meta
//         imagePreview: '/img/transformation.jpg',
//         id: '',
//         type: 'ComparisonWidget',
//         name: 'Transformation',
//         position: '1',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Image',
        
//         // AI Integration
//         aiInfo: aiWidgetInfos.comparisonWidget
//     },

//     // Gallery Widgets
//     galleryWidget: {
//         // Content Properties
//         titleText: 'My Gallery',
//         titleColor: '#000000',
//         titleSize: 36,
//         titleSizeMobile: 28,
//         titleSizeBig: 40,
//         titleWeight: '700',
//         titleFont: '', // Will use globalBigFont
//         titleEffect: '',

//         // Title Highlight Words - EXAKT WIE HEROHEADER
//         titleHighlightWords: '', // Comma separated words to highlight
//         titleHighlightColor: '#D4A574',
//         titleHighlightWeight: '800',
//         titleHighlightSize: 36,
//         titleHighlightSizeMobile: 28,
//         titleHighlightSizeBig: 40,
//         titleHighlightFont: '', // Will use globalSmallFont (different from main title)
//         titleHighlightEffect: '',
//         titleHighlightMarginLeft: 0,
//         titleHighlightMarginRight: 0,

//         // Description Text - RICH TEXT WIE HEROHEADER
//         descriptionText: 'Explore our collection of <strong>beautiful images</strong> and creative projects.',
//         descriptionColor: '#666666',
//         descriptionSize: 18,
//         descriptionSizeMobile: 16,
//         descriptionSizeBig: 20,
//         descriptionWeight: '400',
//         descriptionWeightMobile: '400',
//         descriptionWeightBig: '400',
//         descriptionFont: '', // Will use globalSmallFont
//         descriptionEffect: '',
        
//         // ✅ TEXT WIDTH CONTROLS
//         titleMaxWidth: 800,        // Maximum width of the gallery title (px)
//         descriptionMaxWidth: 600,  // Maximum width of the description text (px)

//         // Gallery Configuration - Echte Bilder aus public/img
//         galleryImages: [
//             {
//                 id: 'img1',
//                 url: '/img/yoga.webp',
//                 alt: 'Yoga and Wellness',
//                 title: 'Peaceful Yoga Session'
//             },
//             {
//                 id: 'img2',
//                 url: '/img/freedom_girl.jpg',
//                 alt: 'Freedom and Success',
//                 title: 'Achieving Freedom'
//             },
//             {
//                 id: 'img3',
//                 url: '/img/personal_branding.jpg',
//                 alt: 'Personal Branding',
//                 title: 'Professional Branding'
//             },
//             {
//                 id: 'img4',
//                 url: '/img/methodology.jpg',
//                 alt: 'Business Methodology',
//                 title: 'Strategic Approach'
//             },
//             {
//                 id: 'img5',
//                 url: '/img/holistic_lady.jpg',
//                 alt: 'Holistic Wellness',
//                 title: 'Holistic Lifestyle'
//             },
//             {
//                 id: 'img6',
//                 url: '/img/girlboss.jpg',
//                 alt: 'Entrepreneurial Success',
//                 title: 'Business Success'
//             }
//         ],

//         // Masonry Grid Settings
//         columnCount: 3,           // Desktop columns (2-5)
//         columnCountMobile: 2,     // Mobile columns (1-3)
//         gridGap: 16,             // Gap between images in px
//         gridGapMobile: 12,       // Mobile gap
        
//         // Image Settings
//         imageRadius: 8,          // Border radius for images
//         enableHover: true,       // Hover effects
//         enableLightbox: true,    // Lightbox functionality
        
//         // Layout & Styling
//         backgroundColor: '#ffffff',
//         marginTop: 0,
//         marginBottom: 40,
//         borderRadius: 0,
//         border: false,
//         borderColor: '#CCCCCC',
//         borderWidth: 2,              // Border width in px (1-5)

//         // ✅ RESPONSIVE LAYOUT PROPERTIES - NEW LAYOUT SYSTEM 2025
//         height: 'auto',            // Auto height for masonry
//         heightMobile: 'auto',      // Auto height mobile
//         paddingTop: 60,            // Desktop Padding
//         paddingTopMobile: 40,      // Mobile Padding
//         paddingBottom: 60,         // Desktop Padding
//         paddingBottomMobile: 40,   // Mobile Padding

//         // Text Alignment & Responsive
//         textAlignment: 'center',        // Desktop Text Alignment
//         textAlignmentMobile: 'center',  // Mobile Text Alignment

//         // Text Spacing
//         titleDescriptionGap: 16,        // Gap between title and description
//         descriptionGalleryGap: 40,      // Gap between description and gallery
//         descriptionMaxWidth: 600,       // Max width for description text

//         // Visibility Toggles
//         showTitleText: true,
//         showDescriptionText: true,

//         // Widget Meta (REQUIRED)
//         imagePreview: '/img/foto1.jpg', // Echtes Foto als Gallery Preview
//         id: '',
//         type: 'GalleryWidget',
//         name: 'Gallery Widget',
//         position: '30',
//         isSelected: false,
//         cat1: 'Fancy',
//         cat2: 'Image',

//         // AI Integration (REQUIRED)
//         aiInfo: aiWidgetInfos.galleryWidget
//     },
    
  };

  
  